export default {
  company: {
    title: "公司动态",
    content: "公司新闻、行业动态、技术进展等最新资讯。",
    news: {
      title: "公司新闻",
      list: [
        {
          id: "startorus-fusion-magnet-test",
          title: "星环聚能完成全球首个全尺寸高温超导磁体测试，上海超导提供全部REBCO带材",
          image: "/images/news/星环聚能完成全球首个全尺寸高温超导磁体测试1.png",
          url: "/news/startorus-fusion-magnet-test",
          date: "2026-06-11",
          content: `近日，星环聚能自主研发的全尺寸环向场磁体顺利完成20 K低温环境下的励磁测试，磁体成功励磁至4.5 kA。作为全球首个面向球形托卡马克聚变堆的全尺寸高温超导环向场磁体，其含线圈盒工程电流密度超40 A/mm²、绕组电流密度达375 A/mm²，经多次测试，性能稳定。
          ---上海超导供应了该磁体绕制所用的全部REBCO超导带材，星环聚能该磁体多次测试且性能稳定，又一次验证了上海超导高温超导带材在复杂工况下的高稳定性，从材料端为聚变堆级磁体的工程化落地提供了有力支撑。
          ---以下为转发内容：
          ---近日，星环聚能自主研发的全尺寸环向场磁体顺利完成20 K（-253.15℃）低温环境下的励磁测试，磁体成功励磁至4.5 kA。该磁体高约4米、宽约2米，尺寸与聚变堆装置完全一致，并非缩比模型。这是全球首个面向球形托卡马克聚变堆的全尺寸高温超导环向场磁体，标志着星环聚能在聚变堆级高温超导磁体工程化道路上迈出了关键一步，也为下一代球形托卡马克装置CTRFR-1（星环一号）的研制奠定了坚实基础。
          ---[[highlight]]极高的工程电流密度：聚变堆级磁体的核心指标[[/highlight]]
          ---对于球形托卡马克而言，中心柱空间极端受限，对磁体的工程电流密度提出了远高于常规托卡马克的要求。该磁体正是为这一极端工况量身设计：
          ---含线圈盒工程电流密度超过40 A/mm²——作为对比，国际热核聚变实验堆（ITER）相应指标公开值仅约10 A/mm²；
          ---绕组电流密度达375 A/mm²——公开文献显示，CFS的SPARC环向场模型磁体绕组工程电流密度约为153 A/mm²，星环这一指标达到其约2.4倍，且同处20 K温区；
          ---本次测试中，磁体成功励磁至4.5 kA，通流比超过60%，通流裕度充足；等效装置中心磁场达到3.06 T、等效装置最大磁场达到11.1 T，各项关键指标均符合预期。
          ---更重要的是，磁体经过多次测试，性能稳定，充分验证了设计、工艺与运行的可靠性。
          ---[[highlight]]不追极端磁场，而追极高电流密度：球形托卡马克的路线选择[[/highlight]]
          ---需要说明的是，球形托卡马克的技术特点决定了它并不追求极端高磁场，而是追求极高的工程电流密度。这正是球形路线区别于常规托卡马克、强场托卡马克的本质所在。在满足约束能力的前提下，更高的电流密度意味着更紧凑的磁体设计与更低的磁体储能，从而降低失超带来的风险、提升运行安全裕度。星环的这一磁体，正是这一路线优势的工程化体现。
          ---[[highlight]]从带材到整机：全链条垂直整合能力[[/highlight]]
          ---本次测试的另一个核心看点，是星环聚能展现出的全链条垂直整合能力——从高温超导带材入厂开始，到磁体绕制、关键零部件、制冷、信号采集与控制系统，绝大部分环节均由公司自主掌握：
          ---带材验收：自主研发的带材磁测量与卷对卷设备，参与了部分带材及带材接头的验收；
          ---线圈绕制：自主研发两代绕线机，完成了全部线圈绕组的绕制；
          ---关键零部件：自主研发的冷却管路绝缘端子、磁体内部接头、电流引线关键部件等关键工艺与核心零部件，成功应用于磁体；
          ---磁体馈线：自主研发的10 kA 级高温超导磁体馈线，已通过初步测试；
          ---制冷系统：自主研发的4900 W 液氮温区冷氦气制冷机作为冷屏冷源，与供应商合作建设的360 W/20 K 冷氦气系统作为磁体冷源；
          ---冷屏与杜瓦：全自主设计、可同时兼容聚变堆极向场磁体与环向场磁体的全尺寸冷屏、杜瓦投入使用；
          ---磁屏蔽系统：面向全尺寸高参数测试，研制了全套磁屏蔽系统，对仪器设备就近保护，更贴近聚变堆真实运行条件；
          ---信号采集：电压、电流、温度、应变、磁场等全部传感器信号，均由自主研发并已商品化的EPIC极端物理综合测试仪采集；
          ---失超检测准备：自主研发了OFDR分布式应变/温度传感系统，可以毫米级空间分辨率连续监测磁体内部的应变与温度分布，为高温超导磁体的失超检测做好了技术准备；
          ---控制系统：基于AI Native开发的控制系统，作为整个测试的控制与监测界面。
          ---[[highlight]]全流程自动化：贴近聚变堆真实运行[[/highlight]]
          ---本次测试中，整体降温与实验过程全部实现自动化，降温速率与最大温差平稳，各系统运行稳定。这不仅验证了该磁体从磁体设计、工艺制造到低温运行的全链条技术路线可行性，也为后续全尺寸工程磁体的批量化生产、以及聚变装置堆芯部件的工程化研制，积累了宝贵的工程数据与实践经验。
          ---[[highlight]]持续向更高电流、更强磁场、更大尺寸迈进[[/highlight]]
          ---该磁体的成功测试，是星环聚能在磁约束聚变工程化进程中取得又一重要成果。未来，星环聚能将继续推进高温超导磁体技术向更高电流、更强磁场、更大尺寸方向迭代升级，加速聚变能源从科学验证走向工程实现，为人类清洁能源的未来贡献"星环力量"。
          ---链接： https://startorus.cn/progress-news/493.html`,
          other: {
            picture1: {
              url: "/images/news/星环聚能完成全球首个全尺寸高温超导磁体测试1.png",
            },
            picture2: {
              url: "/images/news/星环聚能完成全球首个全尺寸高温超导磁体测试2.png",
            },
            picture3: {
              url: "/images/news/星环聚能完成全球首个全尺寸高温超导磁体测试3.png",
            },
          },
        },
        {
          id: "tisco-cooperation",
          onlyInChinese: true,
          title: "攻克高温超导难题，向宝武太钢集团致敬",
          image: "/images/news/向宝武太钢集团致敬1.png",
          url: "/news/tisco-cooperation",
          date: "2026-06-05",
          content: `五年协同攻坚，太钢集团用实干与坚守，书写了国产材料逆袭的传奇，用创新与担当，践行了服务国家重大战略的初心使命，双方的合作仍在深化，太钢将继续坚守央企担当，聚焦国家“卡脖子”技术难题，持续加大研发投入，推动高端材料技术迭代升级，与上下游企业携手共进。
          ---以下为转发内容：
          ---传统钢铁的厚重与超导材料的轻盈，本是两个看似遥远的领域，却在国家破解“卡脖子”技术的征程中，被中国宝武太钢集团与上海超导科技股份有限公司紧紧相连。一场跨越五年的协同攻坚，一次从“受制于人”到“全球领跑”的逆袭，不仅打破了国外在超导核心材料领域的垄断，更彰显了太钢作为央企，扛起“国之重任”、助力国家重大工程的使命与担当。
          ---时间回溯到五年前，我国高温超导产业正陷入一场艰难的困局。作为高温超导带材的核心基础部件，超导基带技术门槛极高，其精密箔材的供应被国外企业牢牢掌控，国内产业100%依赖进口。高昂的采购成本、严苛的技术限制、不可控的交货周期，像三座大山，压在国内超导企业的肩头。仅上海超导一家，当时累计进口原材料的成本就高达1000多万元，全行业陷入“求而不得”的被动局面，国家高温超导重大工程的推进也因此受阻。
          ---[[highlight]]危难时刻，使命在肩[[/highlight]]
          ---作为中国宝武旗下的核心企业、国内特种钢材领域的领军者，太钢集团主动挺身而出。凭借在精密不锈钢材料领域数十年的技术积淀，以及“大国重器”服务国家战略的央企担当，太钢向上海超导抛出橄榄枝，双方携手开启了一场旨在突破核心技术、实现超导基带国产化的攻坚之战。“国家有需求，太钢就有担当。破解超导材料‘卡脖子’难题，我们义不容辞。”当时负责项目攻坚的太钢技术专家的话语，成为双方合作的初心誓言。
          ---太钢充分发挥自身在特种钢材研发制造上的优势，整合“手撕钢”“掩膜板箔材”的研发经验，从原材料选材、熔炼、浇铸，到轧制、退火、酸洗，每一个环节都精益求精、反复打磨。在最关键的超纯净冶炼环节，研发团队研发出专属纯净化技术，通过精准控制熔炼温度与时间，将C276镍基合金中的碳、硫、磷、氧等杂质含量“筛”到低于进口产品的水平，个别指标实现反超，让基带夹杂物综合评级＜0.5，为超导带材的高临界电流打项坚实基础；在超薄精密轧制环节，团队突破“超薄带材易断裂、平整度难控”的行业瓶颈，设计专用轧辊和全流程多维度张力控制工艺，成功轧制出厚度0.03毫米、宽度12毫米、长度超2000米的超长超薄基带，表面粗糙度控制在18纳米以内，最高可达原子级的3纳米平整度；在退火环节，精准把控温度曲线，确保基带经过高温处理后仍能保持超高强度与热稳定性。为了达到这些极致要求，技术人员每天要检测上百组数据，对生产流程进行上千次微调，哪怕是0.001毫米的厚度偏差、1纳米的表面粗糙度波动，都要重新调试、反复试验。上海超导则聚焦超导基带的应用需求，实时开展77K自场临界电流测试，及时反馈数据，为太钢的工艺优化提供精准指引。
          ---五年时间，1800多个日夜，双方携手攻克了一个又一个技术壁垒，突破了一项又一项关键瓶颈。攻坚初期，曾因基带表面粗糙度超标，导致超导层沉积不均，多次试验均告失败；也曾因轧制过程中张力控制不当，出现基带断裂、边缘起皱等问题，让前期投入付诸东流。面对困境，太钢的党员骨干带头冲锋，成立攻坚专班，逐环节拆解难题，针对粗糙度问题优化酸洗工艺，针对张力问题升级轧制控制系统；上海超导的技术团队紧密配合，同步推进应用测试，甚至把测试设备搬到太钢生产线，实现“生产即测试、测试即优化”。从最初的实验室样品，到小批量试产，再到全工业化制程量产，每一步都充满了艰辛与挑战，最终打通了“原料冶炼—热轧开坯—冷轧精整—成品退火”的全流程，形成了规模化生产能力。
          ---[[highlight]]功夫不负有心人，攻坚终获硕果[[/highlight]]
          ---2026年2月份，上海超导向太钢发出感谢信：太钢自主研发的C276镍基合金超导基带，成功通过上海超导全流程验证，搭载该基带的高温超导产品，成功拿下7个全球第一。经检测，用太钢基带制备的高温超导带材，77K自场临界电流均值达705A/12mm，性能与进口产品完全持平，部分批次甚至更优，标志着我国高温超导产业链关键环节实现自主自强，国产超导材料的性能与可靠性达到国际领先水平。这一突破，不仅彻底打破了美国、日本企业在超导基带领域的技术垄断，更实现了超导基带的全面国产化替代，让我国高温超导产业彻底摆脱了对进口材料的依赖。
          ---国产化替代的成效，体现在实实在在的数据与成果中。此前，进口超导基带价格高昂，且交货周期长达数月，严重制约了国内超导产业的发展。太钢超导基带实现规模化生产后，不仅供应稳定，更将相关材料成本大幅降低，为国内超导企业降低了运营成本、提升了市场竞争力。如今，太钢生产的超导基带，已广泛应用于高温超导相关重大工程，为我国超导产业的规模化发展提供了坚实支撑，也为国家重大战略实施筑牢了材料根基。
          ---作为国资央企，太钢集团的使命与担当，不仅体现在破解“卡脖子”技术上，更体现在推动产业链协同发展、助力国家高质量发展的实践中。此次与上海超导的合作，不仅实现了自身技术的突破，更带动了我国高温超导产业链的协同升级，形成了“材料研发—产品制造—产业应用”的完整闭环，为我国高端材料产业自主可控发展提供了“太钢方案”。
          ---[[highlight]]钢芯铸魂，超导致远[[/highlight]]
          ---五年协同攻坚，太钢与上海超导用实干与坚守，书写了国产材料逆袭的传奇，用创新与担当，践行了服务国家重大战略的初心使命。如今，双方的合作仍在深化，太钢将继续坚守央企担当，聚焦国家“卡脖子”技术难题，持续加大研发投入，推动高端材料技术迭代升级，与上下游企业携手共进，为我国高端制造产业自主自强、为支撑党和国家事业发展大局，贡献更多的太钢力量。
          ---链接： <a href="https://mp.weixin.qq.com/s/MYCcSiLvOhs41nz5DzujkQ?mpshare=1&scene=1&srcid=0606n1sXbmhG2KHgfMe7IY91&sharer_shareinfo=16aee1d561ba5ca42f79cbd06bb478ab&sharer_shareinfo_first=592d7d8571ceae144a89b555216289ab&from=industrynews&color_scheme=light#rd" target="_blank" rel="noopener noreferrer">https://mp.weixin.qq.com/s/MYCcSiLvOhs41nz5DzujkQ</a>`,
          other: {
            picture1: {
              url: "/images/news/向宝武太钢集团致敬1.png",
            },
            picture2: {
              url: "/images/news/向宝武太钢集团致敬2.png",
            },
            picture3: {
              url: "/images/news/向宝武太钢集团致敬3.png",
            },
            picture4: {
              url: "/images/news/向宝武太钢集团致敬4.png",
            },
          },
        },
        {
          id: "chaodaodianlanluxiantu",
          title: "超导大功率电缆和线路发展现状及技术路线图",
          image: "/images/news/超导大功率电缆和线路发展现状及技术路线图1.png",
          url: "/news/chaodaodianlanluxiantu",
          date: "2026-05-08",
          content: `超导电缆在实践应用领域取得了诸多实质性的的进展，德国卡尔斯鲁厄理工学院（KIT）的Mathias Noe教授，联合全球超导电缆领域的专家和实践工程师，历时3年整理完成综述文献，全景式地给出来超导电缆的技术里程碑、技术程度度判断及预判超导电缆未来的宏大应用场景。全文于2026年发表于《Superconductor Science and Technology》学术期刊（DOI 10.1088/1361-6668/ae15c2）。<br><br>该综述认为：<br>超导电缆技术正处于从示范验证向早期商业化过渡的关键阶段，其在高功率密度、高效率、节约空间及特殊环境应用方面的独特优势，正通过材料进步、工程设计创新和多样化的示范项目得到充分验证，未来在新型电力系统、绿色工业、交通电气化和综合能源网络等领域前景广阔。
          ---核心主要结论为：<br>1.第二代高温超导（2G HTS）带材性能持续提升与成本下降，为超导电缆商业化行夯实基础。<br>当前带材成本约为80–100 €/(kA·m) （基于77K自场临界电流），预计未来4-5年内可降低约50%。<br><br>2.高效、可靠且多样化的低温冷却系统发展<br>冷却技术是超导系统的关键，多个千米级示范项目（如德国AmpaCity、韩国Shingal）已成功采用液氮（~77 K）闭环冷却系统长期运行。<br>更低温度冷却优势：使用液氢或加压氦气在20-50 K运行，可使REBCO电缆的载流能力大幅提升（相比77K），或减少带材用量以降低成本。<br>低热泄漏：如SuperLink项目开发的低温恒温器，实测热泄漏低至0.8 W/m。
          ---3.解决城市中心高密度供电瓶颈<br>超导电缆凭借其高载流能力和紧凑尺寸，成为解决城市中心区电网扩容、替代高压变电站或简化电网架构的创新解决方案。<br>最值得瞩目为正在规划的“SuperLink”项目，旨在开发一条15公里长的110 kV/500 MVA超导电缆穿越慕尼黑市区。<br><br>4.直流（DC）超导输电技术取得重要突破<br>直流超导电缆无交流损耗，更适合长距离、大容量输电，以及在数据中心、轨道交通、电解工业等需要高电流、低电压的场景应用。<br>高电压直流（HVDC）：欧洲Best Paths项目完成了320 kV/10 kA超导HVDC电缆的类型测试；韩国济州岛有80 kV/3.25 kA示范线路。<br>长距离记录：俄罗斯圣彼得堡的20 kV/2.5 kA直流超导电缆长达2.4公里，是目前最长的示范线路。<br>高电流应用：德国路德维希港的电解工业用直流超导电缆达1 kV/20 kA。
          ---5.面向工业与数据中心的高电流母线/电缆应用<br>在铝电解、氯碱工业、大型数据中心等需要极高直流电流（数十至数百千安）的场合，超导母线/电缆能显著节省空间、材料和能耗。<br>工业大电流：德国DEMO200等项目旨在开发用于铝冶炼厂的200 kA超导直流母线系统。<br>数据中心供电：日本石狩（Ishikari）的500米长20 kV/5 kA直流超导电缆专为数据中心供电而建。<br>性能优势：HTS直流母线系统的电流密度可超过50 kA/cm²，实现零电阻传输。<br><br>6.推动航空与轨道交通电气化<br>超导电缆的高功率密度、轻量化和灵活性，使其成为未来电动飞机和多兆瓦级轨道交通牵引供电系统的理想选择。<br>航空应用：空客ASCEND项目中，10米长、300 V/1700 A的CORC®直流超导链路（重约1.3 kg/m）成功演示，目标功率500 kW，并具备故障限流功能。<br>铁路馈电：法国巴黎的SuperRail项目部署了两条60米长、1.5 kV/3.5 kA的直流超导电缆，以增强蒙帕纳斯火车站的供电能力。日本也有多项1500 V直流铁路网超导馈电试验。
          ---7.新型电缆结构设计提升性能与灵活性<br>CORC®（绕制圆芯导体）等先进电缆结构，优化了电流分布、交流损耗和机械弯曲性能，满足不同应用场景的苛刻要求。<br>CORC®电缆性能：文章列举了多种CORC®设计，例如一种48根带材的电缆，在68-77 K液氮中工作电流（Iopp）达3.5-7 kA，对应功率10-20 MW；在30-50 K下，电流可达14-28 kA，功率达42-84 MW。<br>灵活性：更薄的CORC®“线材”可实现小于0.1米的弯曲半径，适用于空间受限的场合。
          ---8.混合能源管道（电-氢/液化天然气共输）概念验证<br>将超导电缆与输送液态氢（LH₂）或液化天然气（LNG）的管道相结合，实现电能和化学能载体的同步、高效传输，是面向未来综合能源系统的前瞻性技术。<br>电-氢共输：文档提出了结合MgB₂超导电缆和液氢管道的混合能源管线概念，并给出了一个潜在应用的设计参数：长度10 km，电功率0.2 GW (±10 kV, 10 kA)，氢输送功率0.2 GW。<br>电-LNG共输：中国已开展同时传输LNG和电力的超导能源管道原型研发。
          ---9.超导架空输电线路（O-SCTL）开拓新应用场景<br>将超导电缆置于架空低温恒温器中，可在不显著增加走廊宽度的情况下，极大提升现有输电塔的容量，或实现用较低电压等级输送超高功率，为解决输电走廊紧张提供新思路。<br>积极意义：O-SCTL有望以更低的安装成本（相较于地下敷设）、更小的环境影响和更短的审批周期，实现电网拥堵缓解和大规模可再生能源并网。
          ---10. 标准化建立与长期运行经验积累助推商业化<br>国际标准（如IEC 63075）的制定、以及多个示范项目超过数年的无故障连续运行，证明了超导电缆的技术可靠性，增强了电网运营商的信心，正推动其从示范走向商业化。<br>长期运行记录：德国埃森的AmpaCity电缆（10 kV, 2.4 kA, 1 km）原计划运行2年，因表现优异延长至7年，期间被视为普通电网设备运行。<br>标准与认证：IEC 63075已成为超导交流电缆的测试标准；一些新项目（如SuperNode的直流电缆）正依据DNV等机构程序进行资格认证（目标TRL 6）。<br>商业化案例：韩国“Shingal项目”和后续的“Munsan项目”标志着超导电缆已进入商业采购和运营阶段，并开始评估“超导变电站”等新型电网架构。<br><br>链接：<a href="https://mp.weixin.qq.com/s/KW6bQRctg74LoUXaKJ2BvA?sessionid=1774515171&scene=126&subscene=7&clicktime=1774519923&enterid=1774519923&ascene=3&fasttmpl_type=0&fasttmpl_fullversion=8186620-zh_CN-zip&fasttmpl_flag=0&realreporttime=1774519923504&devicetype=android-33&version=2800455b&nettype=cmnet&abtest_cookie=AAACAA==&lang=zh_CN&session_us=gh_7c6ec936e2f3&countrycode=CN&exportkey=n_ChQIAhIQPRunJdVdmriU2YLD7zhDghLxAQIE97dBBAEAAAAAAKL/GqbcpnwAAAAOpnltbLcz9gKNyK89dVj08X4UL+XewusrJQ38xFQcKyFq0NcZZPwh2E+CoeqPf5sAqyGDW/CPaWDtyH/Pw6XoCCFNon+a0Xw7qavFcLwrgJP3b4NOGeRVsLOp8KIsAOxfDY8IYugX0CKNK5kzXvlNHtTYjOjBhzsjJMaDPXCfa0EeytPAYW4sSa70vynTkssoVYx1ApyzoNpsppWvbmECq5zaxfjBaQVwZA9Ddr8QC+zyoqiFGzOdckD/7Fo65GfcH9o6dZbOm40S7fP3zQsckkgAH6/+70SIIsM=&pass_ticket=8XHcQWIsywQuDMwf9PJ7W9oEBrezCmj0pqDPMZYEAhI9fotkqpfOl527PoeLf9cN&wx_header=3&from=industrynews&color_scheme=light" target="_blank">https://mp.weixin.qq.com/s/KW6bQRctg74LoUXaKJ2BvA</a><br>https://iopscience.iop.org/article/10.1088/1361-6668/ae15c2<br>DOI 10.1088/1361-6668/ae15c2`,
          other: {
            picture1: { url: "/images/news/超导大功率电缆和线路发展现状及技术路线图1.png" },
            picture2: { url: "/images/news/超导大功率电缆和线路发展现状及技术路线图2.png" },
            picture3: { url: "/images/news/超导大功率电缆和线路发展现状及技术路线图3.png" },
            picture4: { url: "/images/news/超导大功率电缆和线路发展现状及技术路线图4.png" },
            picture5: { url: "/images/news/超导大功率电缆和线路发展现状及技术路线图5.png" },
            picture6: { url: "/images/news/超导大功率电缆和线路发展现状及技术路线图6.png" },
            picture7: { url: "/images/news/超导大功率电缆和线路发展现状及技术路线图7.png" },
            picture8: { url: "/images/news/超导大功率电缆和线路发展现状及技术路线图8.png" },
            picture9: { url: "/images/news/超导大功率电缆和线路发展现状及技术路线图9.png" },
            picture10: { url: "/images/news/超导大功率电缆和线路发展现状及技术路线图10.png" },
            picture11: { url: "/images/news/超导大功率电缆和线路发展现状及技术路线图11.png" },
            picture12: { url: "/images/news/超导大功率电缆和线路发展现状及技术路线图12.png" },
            picture13: { url: "/images/news/超导大功率电缆和线路发展现状及技术路线图13.png" },
            picture14: { url: "/images/news/超导大功率电缆和线路发展现状及技术路线图14.png" }
          }
        },
        {
          id: "cicc80kajiduan",
          title: "热烈祝贺中科院等离子体所80 kA高温超导CICC导体通过极端测试，上海超导供应全部高温超导带材",
          image: "/images/news/热烈祝贺中科院等离子体所80 kA高温超导CICC导体通过极端测试1.png",
          url: "/news/cicc80kajiduan",
          date: "2026-04-09",
          content: `近日，中国科学院等离子体物理研究所联合中国科学技术大学、合肥工业大学、洛桑联邦理工学院在《Superconductor Science and Technology》期刊发表题为《DC performance test of twisted stacked slotted-core CICC prototype under 80 kA current and 10.85 T background field》的论文。研究团队成功研制出一根长2.8米的大电流高温超导CICC导体，并顺利在瑞士SULTAN完成测试。该CICC导体所使用的全部REBCO高温超导带材均由上海超导提供，再次验证了上海超导带材产品在聚变工况下稳定、可靠的优异性能。
          ---测试结果显示：该CICC导体在77 K自场下Ic达到16.6 kA；在10.85 T背景磁场下，60 kA与70 kA运行电流对应的分流温度分别约为23.5 K和19.6 K。在80 kA电流、10.85 T背景磁场下，导体经过多次电磁循环测试后，其分流温度仅下降1.3%，并在后续循环测试中保持稳定（对应电磁负载约830 kN/m），展现出对高电磁负载的优异耐受性。
          ---值得关注的是，这是目前公开文献中首个在830 kN/m电磁负载下可稳定工作的堆叠型CICC导体实例，为未来强场聚变磁体工程化发展提供了宝贵实验参考。展望未来，上海超导将继续致力于高品质REBCO带材研发与规模化量产，携手国内外科研机构，共同推动可控核聚变应用发展。
          ---论文链接：<a href="https://iopscience.iop.org/article/10.1088/1361-6668/ae4831" target="_blank">https://iopscience.iop.org/article/10.1088/1361-6668/ae4831</a><br>DOI：10.1088/1361-6668/ae4831`,
           other: {
            picture1: {
              url: "/images/news/热烈祝贺中科院等离子体所80 kA高温超导CICC导体通过极端测试1.png",
   
            },
            picture2: {
              url: "/images/news/热烈祝贺中科院等离子体所80 kA高温超导CICC导体通过极端测试2.png",
   
            },
            picture3: {
              url: "/images/news/热烈祝贺中科院等离子体所80 kA高温超导CICC导体通过极端测试3.png",
            }
          }
        },
        {
          id: "chaodaokepujinxiaoyuan",
          title: "超导科普进校园，播撒科学小火种",
          image: "/images/news/超导科普进校园1.png",
          url: "/news/chaodaokepujinxiaoyuan",
          date: "2026-03-26",
          content: `3月26日，上海超导走进复旦大学附属浦东实验学校，带领同学们揭开超导材料的神秘面纱，感受超导技术及应用的奇妙世界，激发对基础科学的探索热情。
          ---活动以“探秘核聚变与高温超导材料”为主线，串起超导材料的科学史话，生动呈现高温超导在可控核聚变领域的创新优势及未来前景。现场设置超导带材生产过程展示、带材产品展示、磁悬浮演示实验区，让同学们沉浸式体验“超导材料工程师”的工作日常。
          ---互动环节中，同学们对“超导磁悬浮列车”“可控核聚变”等前沿话题兴趣浓厚，争相提问，现场气氛热烈。
          ---此次科普活动不仅让同学们领略了超导技术的“神秘”魅力，更在他们心中埋下了探索科学的种子。未来，上海超导将继续履行社会责任，推动前沿科普走进更多校园，助力更多“未来科学家”“未来工程师”的成长。`,
          other: {
            picture1: {
              url: "/images/news/超导科普进校园1.png",
              caption: ""
            },
            picture2: {
              url: "/images/news/超导科普进校园2.png",
              caption: ""
            }
          }
        },
        {
          id: "kongxinhuanxingchaodaobingliandiankangqi",
          title: "世界首台空心环形超导并联电抗器成功在沪投运，上海超导持续助力城市电网升级",
          image: "/images/news/世界首台空心环形超导并联电抗器成功在沪投运1.png",
          url: "/news/kongxinhuanxingchaodaobingliandiankangqi",
          date: "2026-02-10",
          content: `2026年2月10日，由国网上海市电力公司牵头，联合上海翌曦科技、上海交通大学、吴江变压器有限公司等高校与企业共同研制的国际首台10千伏/1兆乏空心环形超导并联电抗器，在35千伏古龙变电站正式投入运行，上海超导供应了该项目所需的全部高温超导带材，为项目的顺利进行提供了高质量的材料支撑。这一成果标志着我国在超导电力装备研发与工程化应用领域实现又一重大突破，为全球城市电网升级提供了创新型解决方案。
          ---本次投运的超导并联电抗器采用了“零电阻、高通流”的超导材料，设计了无铁心环形拓扑结构，占地面积不足6平方米，较传统设备减少超60%，运行噪声低于60分贝，且空间漏磁近乎为零，可无缝接入现有变电站系统，实现“即插即用”式升级。该项目也是继35千伏公里级超导电缆示范工程后，在上海市城市电网中又一个成功投入应用的超导项目。春节期间，这台10kV超导电抗器为闵行主城区古龙变电站周边2.2万户居民和多所学校提供容量1Mvar的无功，稳住电压，为周边居民家用电器筑起隐形护盾。
          ---该超导电抗器的成功投运，解决了城市电网无功补偿的结构性难题，将进一步助力超导技术在城市旧站改造、新站建设等城市电网升级中的推广应用。`,
          other: {
            picture1: {
              url: "/images/news/世界首台空心环形超导并联电抗器成功在沪投运1.png",
              caption: "世界首台空心环形超导并联电抗器"
            },
            picture2: {
              url: "/images/news/世界首台空心环形超导并联电抗器成功在沪投运2.png",
              caption: "世界首台空心环形超导并联电抗器"
            }
          }
        },
        {
          id: "sst2025summary",
          title: "攻坚结硕果乘势启新程",
          image: "/images/news/攻坚结硕果1.png",
          url: "/news/sst2025summary",
          date: "2026-02-05",
          content: `时逢新岁，春启华章。2026年2月6日，上海超导全体同仁齐聚一堂，召开2025年经营成果总结大会暨2026年经营计划颁布大会，总结回顾，规划征途。
          ---<b>回顾2025：厚积成势，硕果盈枝</b><br><br>2025年度，上海超导“深耕”产业，交出了一份亮眼的成绩单：
          ---<b>产业能力快速壮大</b>——二期达产，年产能达到4000公里/年（宽带），积极推进自动化生产系统，有效提升生产效率与产品质量稳定性；三期扩产项目开工，成为张江科学城首个实现“拿地即开工、交地即交证”五证连发的标杆案例。
          ---<b>研发成果显著</b>——与山西太钢协同攻关的基带国产化项目顺利实现了超导基带的工业化量产，自建完成年产1000块超导靶材的产能——2025年全材料系统国产化的目标已全面实现。
          ---<b>市场再创佳绩</b>——国内外市场持续深耕发力，全年共有9个应用项目取得突破性进展，覆盖可控核聚变、大电流高温超导导体、高场磁体、超导电缆、超导电抗器、超导储能系统、超导单晶炉设备等应用领域，进一步加深和巩固了核心客户市场，并开拓和支撑更多新兴应用市场发展；参展参会20余场重要活动，包括中国制造“十四五”成就展、第二十五届工博会等国家级展会，及MT29、EUCAS2025、全国超导大会等行业核心学术会议，凭借上海超导专业的售前技术沟通和售后支持，及过硬的产品实力，上海超导品牌影响力从“行业知名”向“用户首选”迈进。
          ---<b>资质荣誉硕果累累</b>——荣获“工信部制造业单项冠军企业”“上海市创新型企业总部”“上海市科技小巨人”等资质，入选2025年上海市重大工程清单、长三角创新产品应用示范案例、制造业单项冠军企业创新优秀案例、上海行业标准榜TOP50，荣获中国国际工业博览会CIIF大奖、全国颠覆性技术创新大赛优胜奖、国际创新创业大赛总决赛二等奖等奖项，全年新增授权专利12项。
          ---<b>致敬奋斗：榜样引领，聚力成光</b><br><br>每一项成绩的背后，都是无数平凡员工的拼搏身影。年会上，上海超导对2025年度表现突出的先进个人与集体进行了隆重表彰。
          ---本次共颁发“超导之星”“勤勉之星”“先进集体”等奖项，他们是攻坚克难的尖兵，是精益求精的工匠，是默默耕耘的脊梁。他们的榜样引领作用，将激励每一位同仁见贤思齐、再攀高峰。
          ---<b>精彩年会：超导速达，马启新章</b><br><br>会后，公司举办了2025年度晚宴，整场活动精彩纷呈。员工们自编自导的文艺节目轮番上演，既有激情澎湃的歌曲演唱，也有幽默诙谐的小品表演，更有展现团队协作的舞龙，每一个环节都将现场气氛推向高潮。大家在欢声笑语中举杯同庆，分享着过去一年的收获与喜悦，也为新一年的奋斗积蓄着力量。
          ---<b>展望2026，共赴新征程</b><br><br>站在新的起跑线上，上海超导将保持战略定力，坚定不移地走高质量发展之路，以技术、产品与服务构筑最坚实的护城河，与客户协同并进，共同书写超导产业的新篇章！`,
          other: {
            picture1: {
              url: "/images/news/攻坚结硕果1.png",
              caption: "2025年经营成果总结大会暨2026年经营计划颁布大会"
            },
            carouselImages: [
              { url: "/images/news/攻坚结硕果2.png" },
              { url: "/images/news/攻坚结硕果3.png" },
              { url: "/images/news/攻坚结硕果4.png"},
              { url: "/images/news/攻坚结硕果5.png" },
              { url: "/images/news/攻坚结硕果6.png"},
              { url: "/images/news/攻坚结硕果7.png" },
              { url: "/images/news/攻坚结硕果8.png" },
              { url: "/images/news/攻坚结硕果9.png" },
              { url: "/images/news/攻坚结硕果10.png" },
              { url: "/images/news/攻坚结硕果11.png" },
              { url: "/images/news/攻坚结硕果12.png" }
            ],
            dinnerImages: [
              { url: "/images/news/攻坚结硕果13.png" },
              { url: "/images/news/攻坚结硕果14.png" },
              { url: "/images/news/攻坚结硕果15.png" },
              { url: "/images/news/攻坚结硕果16.png" },
              { url: "/images/news/攻坚结硕果17.png" },
              { url: "/images/news/攻坚结硕果18.png" },
              { url: "/images/news/攻坚结硕果19.png" },
              { url: "/images/news/攻坚结硕果20.png" },
              { url: "/images/news/攻坚结硕果21.png" },
            ],
            // video: "/video/news/sst2025summary.mp4"
          }
        },
        {
          id: "quanchaodaoyonghuciti356t",
          title: "35.6特斯拉！我国全超导用户磁体取得重大突破",
          image: "/images/news/我国全超导用户磁体取得重大突破.png",
          url: "/news/quanchaodaoyonghuciti356t",
          date: "2026-01-28",
          content: `近日， <b>一个创纪录全高温超导磁体由中科院电工所完成研制并交付使用，该磁体在可用孔径和中心磁场强度上，均创造了新的纪录</b> 。尤其值得关注的是， 该磁体为<b>“用户磁体”，是一个具备科研功能的，可以日常使用的高场磁体，可助力物质科学、生命科学等学科的科研人员探索微观世界</b> 。此类磁体的工程化过程面临多重技术瓶颈，对磁场强度、稳定度、均匀度、有效口径以及长期运行可靠性等指标有着极高要求，研制难度极大。中国科学院电工所王秋良院士团队联合了中国科学院物理所科研团队合作攻关，实现了全高温超导用户磁体性能的跨越式突破，是我国强磁场技术领域的重大成果。
          ---<b>上海超导荣幸地为该磁体供应了超导材料，并参与到这一新纪录的诞生，公司所提供的高一致性大长度带材有力支撑了该磁体的成功研制</b> 。用户磁体需要 <b>长时间、反复使用</b> ，能够选用上海超导的带材是客户单位对我司产品 <b>长期服役状态下的稳定性</b> 的充分肯定。
          ---以下为中国科学院电工研究所官网新闻：
          ---近日，电工所王秋良院士团队依托国家重大科技基础设施-综合极端条件实验装置，实现了35.6特斯拉(T)全超导磁体，创造了全超导用户磁体新的世界纪录。此次技术突破是在电工所之前研制的30特斯拉全超导磁体基础上实现的优化升级。
          ---经专家现场测试，该全超导磁体中心磁场达35.6特斯拉，可用孔径为35毫米，是支持国内外科研团队开展前沿研究的用户磁体。该成果打破了此前由美国国家强磁场实验室创造的32.0特斯拉（可用孔径34毫米）全超导用户磁体的世界纪录，将最高磁场提升了3.6特斯拉，奠定了我国在强磁场全超导用户磁体领域的世界领先地位。
          ---该成果是我国强磁场技术领域的重大突破，将为物质科学、生命科学等前沿研究提供核心支撑的极端强磁实验条件，助力科研人员探索微观世界的未知规律，加速推动我国乃至全球在基础研究及高端装备制造领域的重大科学发现与技术革新。
          ---强磁场超导磁体是一种能在极低温条件下实现零电阻和强磁场的装置，具有极高的磁场强度、极高的均匀度和稳定性，且能耗极低，是现代科技领域的核心装备之一，在国家重大科技基础设施、先进科学仪器、高端医疗装备、能源交通以及国防特种装备等领域具有重大应用价值。强磁场超导磁体研制涉及多学科交叉融合，工程化过程面临多重技术瓶颈，对磁场强度、稳定度、均匀度、有效口径以及长期运行可靠性等指标有着极高要求，研制难度极大。
          ---针对上述技术难题，电工所科研团队研制出超导磁体系统，突破强磁场用户超导磁体设计与建造关键技术，创新提出高场高温超导磁体全电磁精细设计理论与电磁结构随动调整方法、多线圈轴向自适应预紧、分区屏蔽电流抑制等关键核心技术，大幅提升了强磁场超导磁体的电磁－机械安全裕度；物理所科研团队克服了高温超导磁体健康监测、极低温下极高磁场准确测量等方面的难题。此次双方合作攻关，实现了全超导磁体性能的跨越式突破。
          ---未来，团队将进一步发展高场超导磁体技术，为国家重大科技基础设施建设、先进科学仪器研发、国防安全保障等领域提供国际顶尖水平的强磁场技术支撑，为国家重大战略实施注入强劲科技动力。
          ---来源：<a href="https://iee.cas.cn/xwzx/kydt/kxdt2020_241134/202601/t20260128_8119783.html" target="_blank">https://iee.cas.cn/xwzx/kydt/kxdt2020_241134/202601/t20260128_8119783.html</a>`,
          other: {
            picture1: {
              url: "/images/news/我国全超导用户磁体取得重大突破.png",
              caption: "我国全超导用户磁体取得重大突破"
            },
            picture2: {
              url: "/images/news/我国全超导用户磁体取得重大突破2.png",
              caption: "我国全超导用户磁体取得重大突破"
            },
          },
        },
        {
          id: "zhujiqiangguolu",
          title: "筑基强国路，上海超导参展中国制造“十四五”成就展",
          image: "/images/news/上海超导参展中国制造“十四五”成就展1.png",
          url: "/news/zhujiqiangguolu",
          date: "2025-12-29",
          onlyInChinese: true,
          content: `2025年12月29日，由中国国家博物馆、工业和信息化部新闻宣传中心联合主办的“筑基强国路——中国制造‘十四五’成就展”正式开幕，是2025年度中国国家博物馆“国家展览”项目之一，300余件（套）展品全景呈现“十四五”期间中国制造蓬勃发展的历程。上海超导的千米级稀土钡铜氧高温超导带材产品参展，是产业基础展区前沿新材料领域的典型创新案例之一。
          ---工业和信息化部党组成员、副部长张云明开幕在致辞中说，“十四五”期间，我国制造业发展取得新的历史性成就，在国民经济中的“压舱石”作用更加凸显，创新动能更加澎湃，产业结构更加优化，数智化应用更加普及，产业基础更加牢固，专精特新“金字招牌”更加闪亮，透过300余件（套）展品，我们能看到制造业智能化的坚实步伐、绿色化的强劲动能、融合化的广阔前景，有利于进一步营造全社会关心支持制造业发展的浓厚氛围，为推进新型工业化、建设制造强国汇聚磅礴力量。
          ---上海超导的高温超导带材产品，可支持可控核聚变、超导电缆、高场磁体等多个领域的颠覆性创新，本次获选参展，是对上海超导技术创新和产业创新发展成果的重要肯定，“十五五”新征程即将启航，上海超导将以更大的决心，支撑更多新技术新产品规模化商业化应用。`,
          other: {
            picture1: {
              url: "/images/news/上海超导参展中国制造“十四五”成就展1.png",
              caption: "上海超导参展中国制造“十四五”成就展",
            },
            picture2: {
              url: "/images/news/上海超导参展中国制造“十四五”成就展2.png",
            },
            picture3: {
              url: "/images/news/上海超导参展中国制造“十四五”成就展3.png",
            },
            picture4: {
              url: "/images/news/上海超导参展中国制造“十四五”成就展4.png",
            },
            picture5: {
              url: "/images/news/上海超导参展中国制造“十四五”成就展5.png",
            },
          },
        },
        {
          id: "zizhibacai300",
          title: "第300块自制超导靶材！上海超导年产千块产能目标达成 ，全面实现全材料系统国产化",
          image: "/images/news/第300块自制超导靶材1.png",
          url: "/news/zizhibacai300",
          date: "2025-12-18",
          onlyInChinese: true,
          content: `12月18日，上海超导研发及生产的第300块自制超导靶材下线，这意味着上海超导年产1000块超导靶材的产能建设完美达产。超导靶材的成功，让企业内部完备了核心功能层靶材的自制能力，标志着全材料系统国产化的研发与生产目标已全面实现。
          ---2024年第一季度，上海超导正式启动了从原料粉体到靶材压制的全制程国产化研发项目。从研发项目设立初期，就面临着从原料选型开始的诸多技术困难，整个制程中每个技术环节的略微差异，都将会带来靶材整体品质的下降，进而影响到超导膜层的品质。不同技术路线制成的靶材，对于超导膜层的镀膜工艺，也有不同的技术要求。从粉末到靶材到镀膜的全生产流程中，这些技术细节相互耦合，每个环节互相影响，任何一个技术细节参数的偏差，都将影响最终产品品质。研发攻关项目设立初期，项目团队就全流程的评估了每个技术细节，针对工业级大尺寸靶材对压制效率、性能一致性的要求，从原料纯度与颗粒度、超导粉体合成、颗粒度级配、热压模具结构优化到成型烧结、尺寸修整、热处理等，每个技术细节进行打磨，并建立了超导靶材批量制备的质控与性能评价标准，建立适配超导靶材的多维度检测矩阵，最终获得了全流程国产化超导靶材的丰硕成果。
          ---2024年12月，镀膜生产线试用的某批全国产流程自制靶材所制备出的超导带材，在测试环节传来喜讯：自制靶材制成的超导膜层，已经完全贴合进口靶材的性能——这意味着摸索近1年的靶材自制研发项目取得了喜人的阶段性研发成果。
          ---以这批靶材的工艺为依托，研发团队进一步开展了工业化批量生产工艺的探索、定型工作。至2025年2月，企业自制靶材的工业化高一致性已经稳定，自制靶材开始有效支撑带材生产。依托靶材自制的能力，进一步开展不同配方体系的REBCO高温超导带材研究，旨在持续提升批量化带材的临界电流性能、具备了超导靶材成分调控自由——更多的靶材元素组份探索也伴随着靶材生产工艺的稳定平行推进。在这个过程中，项目团队在新靶材组份、高品质产品方面取得了长足进步，支撑了元素调配带来的更多前沿性研发项目成果，同时，在灵活调控人工钉轧的形成方面，获得了更深入了理解和发现。
          ---从进口靶材——返压靶材——摸索原料粉体性能——反复试错打磨工艺——靶材成功，中间得到了很多管理部门、研究平台及企业的支持，而几百天如一日在烧结炉边守候的年轻团队，“烧烤”出来的汗水浇灌出了一块块性能超越进口靶材的成果。
          ---目前，上海超导靶材产能扩产项目已经启动，更高更强的靶材制备能力，将更好地满足高温超导带材从研发到生产的高频度要求，在高温超导带材的细分领域，建设更完备的综合竞争实力。`,
          other: {
            picture1: {
              url: "/images/news/第300块自制超导靶材1.png",
              caption: "第300块自制超导靶材下线",
            },
            picture2: {
              url: "/images/news/第300块自制超导靶材2.png",

            },
            picture3: {
              url: "/images/news/第300块自制超导靶材3.png",
              caption: "高性能自制靶材",
            },
          },
        },
        {
          id: "demo4",
          title: "全球首次！英国TE公司DEMO4磁体成功实现聚变电厂级高场强",
          image: "/images/news/全球首次！英国TE公司DEMO4磁体成功实现聚变电厂级高场强1.png",
          url: "/news/demo4",
          date: "2025-11-24",
          onlyInChinese: true,
          content: `2025年11月19日，英国TE公司宣布，其研发的Demo4高温超导磁体在-243℃（30K）条件下成功达到11.8T的磁场场强，中心螺线管电流达到700万安匝，这是高温超导聚变磁体技术首次在满足未来聚变发电厂所需的磁场环境下取得的突破性成果。上海超导与TE公司深度合作，为该项目分批供应了高温超导带材，用于其强场磁体研制及超导可控核聚变。
          ---Demo4验证了高温超导磁体能够产生聚变发电所需的高强度磁场，为实现清洁、无限、安全的聚变能源并网供电提供了关键的技术解决方案。该项目凝聚了TE公司十余年来在高温超导磁体领域的持续创新，为未来聚变发电系统积累了宝贵的工程数据和建造经验。
          ---Demo4的测试成功，进一步推进高温超导可控聚变技术的发展。
          ---来源：<a href="https://tokamakenergy.com/2025/11/19/tokamak-energy-announces-fusion-power-plant-magnet-technology-breakthrough/" target="_blank">https://tokamakenergy.com/2025/11/19/tokamak-energy-announces-fusion-power-plant-magnet-technology-breakthrough/</a>`,
          other: {
            picture1: {
              url: "/images/news/全球首次！英国TE公司DEMO4磁体成功实现聚变电厂级高场强1.png",
              caption: "Demo4高温超导磁体",
            },
            picture2: {
              url: "/images/news/全球首次！英国TE公司DEMO4磁体成功实现聚变电厂级高场强2.png",
              caption: "TE公司与上海超导合作",
            },
          },
        },
        {
          id: "zhaojiaoji",
          title: "热烈祝贺中科院等离子体所兆焦级10kA载流迫流冷却高温超导储能磁体系统研发成功",
          image: "/images/news/热烈祝贺中科院等离子体所兆焦级10kA载流迫流冷却高温超导储能磁体系统研发成功.png",
          url: "/news/zhaojiaoji",
          date: "2025-11-22",
          onlyInChinese: true,
          content: `2025年11月18日，中科院等离子所宣布成功研发兆焦级10kA载流迫流冷却高温超导储能磁体系统，顺利完成低温励磁性能测试、并通过专家组评审。上海超导与中科院等离子体所紧密合作，为该磁体系统提供了项目所需的全部高温超导材料，在关键材料与工艺支撑方面发挥了重要作用。
          ---该成果解决了高载流、迫流冷却等一系列关键技术难题，系统最高载流达10.5kA，迫流冷却压降低于0.5bar，并在6kA、200A/s快速励磁过程中将线圈温升控制在2K以内，实现高载流下长时稳定和快速交变电流运行。评审专家组一致认为相关技术处于国际领先水平，下一步可拓展应用于核聚变、大型加速器和强磁场装置等领域。
          ---该项目的成功，不仅提升了我国在大科学装置核心部件方面的自主研发实力，也彰显了高温超导技术作为变革性前沿技术，在聚变能源、高端医疗、大科学装置、高速磁悬浮等广阔领域的巨大应用潜力和商业价值。
          ---来源：<a href="http://www.ipp.ac.cn/xwdt/kydt/202511/t20251121_798768.html" target="_blank">http://www.ipp.ac.cn/xwdt/kydt/202511/t20251121_798768.html</a>`,
          other: {
            picture1: {
              url: "/images/news/热烈祝贺中科院等离子体所兆焦级10kA载流迫流冷却高温超导储能磁体系统研发成功.png",
              caption: "兆焦级10kA载流迫流冷却高温超导储能磁体系统",
            },
          },
        },
        {
          id: "kitfangwen",
          title: "德国KIT研究员到访上海超导考察交流",
          image: "/images/news/KIT研究员.png",
          url: "/news/kitfangwen",
          date: "2025-10-01",
          onlyInChinese: true,
          content: `2025年10月，德国卡尔斯鲁厄理工学院（KIT）研究员Sousa博士到访上海超导，实地了解上海超导的技术研发、规模化生产及质量控制体系等方面的建设情况，并就高温超导材料及应用的未来发展趋势与合作展开了深入交流。上海超导总裁朱佳敏等陪同参观，并详细介绍了公司的技术创新进展、产能扩展计划等。
          ---从实验室成果产业化，上海超导在在工艺研发、质量管控、技术服务及产业合作等方面都取得了一系列突破。Sousa博士表示：“亲眼看到上海超导如何将超导材料从实验室研究成果逐步转化为可靠的工业产品，令人倍感振奋！公司对创新和质量的坚持，为全球超导应用领域的合作开辟了广阔前景”。
          ---未来，上海超导将继续坚持技术创新、产业创新，与国内外客户紧密合作，提供高性能、高可靠性的超导带材和服务，共同推动超导技术在能源、电力、工业等更广泛领域的规模化应用。
          ---来源：<a href="https://www.itep.kit.edu/rtset/english/Keynote_China_and_Korea.php" target="_blank">https://www.itep.kit.edu/rtset/english/Keynote_China_and_Korea.php</a>`,
          other: {
            picture1: {
              url: "/images/news/KIT研究员.png",
              caption: "德国KIT研究员到访上海超导",
            },
          },
        },
        {
          id: "quanchaodiancitixinjilu",
          title: "全超导磁体新纪录诞生，上海超导带材产品再创佳绩！",
          image: "/images/news/全超导磁体新纪录诞生3.png",
          url: "/news/quanchaodiancitixinjilu",
          date: "2025-09-26",
          onlyInChinese: true,
          content: `由上海超导提供带材的大口径全超导磁体，于9月26日在合肥再次创下佳绩——由多个顶级科研机构共同开发的全超导大口径磁体创造了35.1T新磁场强度纪录，并在稳定运行30分钟后安全退磁，等待下一次的极限测试。
          ---这一突破性成果一经发布，就被央视新闻和新华社等媒体相继报道，是国际高温超导磁体领域的重要里程碑，充分体现了在材料、磁体领域，我国的实力水平。
          ---35.1T的磁场强度，是地球磁场的70.2万倍，在该磁体的腔体内，形成了地球的又一个新的极限；在35.1T的磁场强度下，每0.01平方米面积的磁力，理论上可以吸起或者举起500吨重量的物体，如此巨大磁力对高温超导材料的要求极为严苛。
          ---上海超导多年来深耕高温超导带材的研发、生产，不仅在电性能提升方面取得了显著成果，更将目光聚焦于带材力学性能的推升，让高温超导产品的实用性极大增强，公司成熟批量化的带材在国内外多形态磁体、多极限纪录磁场强度测试下，屡创突破性佳绩。目前，上海超导带材已被证明拥有面对极端磁场环境下抗脱层能力和极高的稳定性。同期在美国高场实验室用上海超导带材绕制的磁体，是国际上率先呈现在数十特斯拉等级磁场条件下经历反复失超，磁体性能不出现退降的产品，且经过了不同批次的带材在多个磁体中独立重复实验验证。
          ---该35.1T磁体的成功励磁，不仅实现了国际上超高场全超导稳态磁体领域的关键性技术突破，也是上海超导批量化供应高性能高温超导带材能力的又一力证，在漫长的验证过程中，上海超导的批量化产品逐次、长时间内多类型实验均获得了认证通过，推动"核心技术攻关+关键材料国产化"深度协同，未来上海超导将继续坚持技术创新研发、核心性能攻关，加快提升批量化供货能力，为强场科学研究、可控核聚变、超导电力应用等产业化应用夯实材料基础。`,
          other: {
            picture1: {
              url: "/images/news/全超导磁体新纪录诞生1.png",
            },
            picture2: {
              url: "/images/news/全超导磁体新纪录诞生2.png",
            },
          },
        },
        {
          id: "nanwangdaoti",
          title:
            "热烈祝贺南网成功研制国内首根百米级高载流高温超导导体，上海超导供应全部高温超导带材",
          image: "/images/news/20251020南网成功研制百米级高温超导导体1.png",
          url: "/news/nanwangdaoti",
          date: "2025-10-20",
          onlyInChinese: true,
          content: `近日，南方电网成功研制基于CORC（圆芯电缆）与TSTC（堆叠电缆）两种子缆结构的两根百米级大电流高温超导导体，并通过测试与验收。
          在液氮温度自场下载流量达到20千安，在液氦温度15特斯拉磁场下载流量超过50千安。
          以“长度最长、载流量最高”的优势刷新高温超导大电流导体技术纪录，标志着我国百米级的大电流高温超导导体研究获得了成功。
          ---广东电网公司电力科学研究院自2023年起开展高温超导磁体专项研究，针对“超大电流导体结构优化”“超导带材成缆应力控制”“高精密成缆工艺”等关键问题开展技术攻坚，最终实现长尺寸导体电学载流量与力学稳定性的双重突破，该项目的成功，进一步夯实高温超导大型导体在高场磁体应用的诸多技术基础。
          ---上海超导与南方电网紧密合作，为该项目提供了项目所需的全部高温超导材料，在子缆和导体的研究工作中发挥了重要支撑作用。在后续线圈和装置研制中，上海超导将继续全力保障项目高质量顺利推进，助力高温超导高场磁体技术不断创新纪录、迈向更高的发展水平。
          ---来源：南方电网报`,
          other: {
            picture1: {
              url: "/images/news/20251020南网成功研制百米级高温超导导体1.png",
            },
            picture2: {
              url: "/images/news/20251020南网研制百米级高温超导导体2.png",
            },
          },
        },
        {
          id: "huanyihuanjiasupao",
          title: "上海超导“缓一缓就加速跑”团建行",
          image: "/images/news/20251031团建合影.png",
          url: "/news/huanyihuanjiasupao",
          date: "2025-10-31",
          content: `2022年以来，上海超导团队快速壮大，壮大的团队支撑公司完成了一个个看似不可能的任务：十倍扩产落地、核心技术的再升级、卡脖子问题的突围、全球更多客户的认可、更宏大项目基地的开建，每一步攻坚的成果，都是团队智慧、拼搏、担当最完美的注脚。
            ---回首三年，全员团建竟然在忙碌中一直被延期，——这是一个充满欢乐的团队，却三年没有欢玩闲暇。秋高气爽忙里偷闲，三天团建，补上三年的缺憾。即便游玩，也有明显的工作属性——上海超导的浙江安吉团建行，带着“缓一缓就加速跑”的工作目标。
            ---本次团建汇集破冰热身、露营烧烤、篝火晚会、徒步赏景、登高望远等活动，既有纵声歌唱的释放，也有团队协作的默契，欢声笑语中深化理解，挑战突破中凝聚共识，共同诠释了：唯有将个人理想熔铸于强大的信念，方能众志成城在产业发展中成就领航。
            ---上海超导团队会证明：愿景，让每一个平凡凝聚成非凡，让每个不可能都成为里程碑。 缓一缓，就让我们加速跑。`,
          other: {
            picture1: { url: "/images/news/20251031团建合影.png" },
            picture2: { url: "/images/news/20251031团建集锦.png" },
          },
        },
        {
          id: "veirstar3mw",
          title:
            "VEIR成功完成STAR超导输电示范工程、突破AI数据中心供电瓶颈",
          image: "/images/news/STAR超导输电示范工程.png",
          url: "/news/veirstar3mw",
          date: "2025-11-13",
          content: `11月12日，美国VEIR公司成功完成了其首代面向AI数据中心应用的超导技术示范项目（first-generation Superconducting Technology for AI Racks, STAR），通过单根低压超导电缆在模拟数据中心环境中稳定输送了3兆瓦电力。这一突破性进展，解决了AI数据中心发展中电力输送这一关键瓶颈问题。与传统方案相比，该技术可实现10倍以上的功率传输能力、5倍以上的覆盖距离，同时超导电缆布线占地面积减少超过20倍，为数据中心实现更高计算密度、更低延迟和更灵活的设计提供了可能。
          ---VEIR的此次成功演示，标志着其开创性的低压超导电缆技术已具备商业化应用条件，能够安全高效地为AI工厂和数据中心输送电力。随着国际能源署预测全球数据中心用电量将在未来五年内翻番，单个AI服务器机柜功率需求超过500千瓦，传统电力基础设施已不堪重负。VEIR的技术正是在此背景下应运而生。
          ---该项目的成功，也标志着在高用电强度的大终端使用场景，超导电缆低电压大电流输送大功率电力的优势，可带来快速、简洁、低成本的部署方案，具备对传统输送电力模式的升级替代能力，已经开始进入应用场景的拓展加速阶段。
          ---来源：<a href="https://veir.com/veir-successfully-demonstrates-3-megawatt-superconducting-power-delivery-for-ai-data-centers-eleminating-critical-growth-bottleneck/" target="_blank">https://veir.com/veir-successfully-demonstrates-3-megawatt-superconducting-power-delivery-for-ai-data-centers-eleminating-critical-growth-bottleneck/</a>`,
          other: {
            picture1: {
              url: "/images/news/STAR超导输电示范工程.png",
            },
          },
        },
        {
          id: "xinwen3",
          title: "上海超导参展工博会：斩获CIIF大奖，与可控核聚变同台亮相",
          image: "/images/news/上海超导参展工博会1.jpg",
          url: "/news/xinwen3",
          date: "2025-09-23",
          onlyInChinese: true,
          content: `9月23日，以“工业新质，智造无界”为主题的第二十五届中国国际工业博览会在国家会展中心（上海）开幕，开幕式上正式揭晓CIIF大奖及CIIF特别大奖并举行颁奖仪式。
          ---[[highlight]]上海超导荣获本届中国工博会CIIF大奖，数万个展品中仅有10个！[[/highlight]]
          ---工博会是代表国家最高级别的工业产品展览会，工博会奖项在制造业企业以及高科技产品领域含金量极高。
          ---上海超导“高温超导带材”产品参加本次工博会，经过多轮评审和角逐，[[highlight]]最终获得“工博会CIIF大奖”，在整个工博会数万个展品中仅有10个大奖。[[/highlight]]本次获奖，使上海超导成为新材料产业展中备受瞩目的焦点，也是对上海超导在高温超导材料领域的技术实力和大批量稳定供货能力的充分肯定。
          ---[[highlight]]可控核聚变工程密集亮相工博会，上海超导与聚变同台，高温超导材料助力聚变商业化[[/highlight]]
          ---本次工博会，多个可控核聚变装置首次亮相，其中包括“国家队”中国聚变公司计划建设的环流器四号，将采用全高温超导材料，目标在2050年前实现商业发电。还有上海民营聚变公司能量奇点，他们展出了全球首台全高温超导托卡马克装置“洪荒70”和全球最高场强高温超导磁体“经天磁体”。
          ---[[highlight]]上海超导生产的高温超导带材作为未来可控核聚变装置小型化和商业化的重要支撑材料，非常荣幸受邀和这些具有国际影响力的聚变装置同台展示，[[/highlight]]上海超导的产品同时参展国家新型工业化暨“十四五”工业重大成就展、未来工业创新展、新材料产业展三大展区。公司全方位、多角度地向观众展示上海超导的第二代高温超导带材的先进生产技术、扩产进展、批量化稳定供货能力、下游应用案例及其发展前景等情况。
          ---[[highlight]]更有系列交流活动，共话材料未来[[/highlight]]
          ---本次工博会期间，科技部核聚变发展中心主任王艳、中国聚变公司总经理张立波以及上海市科委领导等一行莅临上海超导调研交流，详细调研了上海超导的生产现状、扩产进程和供货情况，深入了解上海超导已成功供货的国内外聚变项目情况，并期望上海超导在推动可控核聚变产业良性、稳步、快速发展中发挥更大材料支撑作用。
          ---同期，上海超导董事长马韬先生受邀参加工博CIIF talk直播、凤凰网采访等一系列精彩活动，与大家分享上海超导及高温超导材料作为新材料、新技术，从实验室研发到规模化稳定量产的艰苦攻关历程，展望高温超导技术在城市电网、清洁能源、高速交通等领域的应用前景和深远影响。
         `,
          other: {
             picture1: {
              url: "/images/news/上海超导参展工博会1.jpg",
            },
            picture2 : {
              url: "/images/news/上海超导参展工博会2.jpg",
            },
            picture3: {
              url: "/images/news/上海超导参展工博会3.jpg",
            },
            picture4: {
              url: "/images/news/上海超导参展工博会4.jpg",
              description:
                "上海超导与能量奇点位于1.1馆国家新型工业化暨“十四五”工业重大成就展的联合展台（展位号C001）",
            },
            picture5: {   
              url: "/images/news/上海超导参展工博会5.jpg",
              description:
                "上海超导与能量奇点位于1.1馆国家新型工业化暨“十四五”工业重大成就展的联合展台（展位号C001）",
            },
            picture6: {
              url: "/images/news/上海超导参展工博会6.jpg",
              description:
                "中国聚变公司将在上海新建高温超导聚变装置—“中国环流四号”",
            },
            picture7: {
              url: "/images/news/上海超导参展工博会7.jpg",
              description:
                "上海超导位于5.2H馆未来工业创新展的展台（展位号：T007）”",
            },
            picture8: {
              url: "/images/news/上海超导参展工博会8.jpg",
              description:
                "中国聚变公司将在上海新建高温超导聚变装置—“中国环流四号”",
            },
            picture9: {
              url: "/images/news/上海超导参展工博会9.jpg",
            },
            picture10: {
              url: "/images/news/上海超导参展工博会10.jpg",
            },
          },
        },
        {
          id: "xinwen1",
          title:
            "上海超导组织观看纪念中国人民抗日战争暨世界反法西斯战争胜利80周年大会",
          image: "/images/news/93阅兵.png",
          url: "/news/xinwen1",
          date: "2025-09-03",
          onlyInChinese: true,
          content: `9月3日上午，纪念中国人民抗日战争暨世界反法西斯战争胜利80周年大会在北京天安门广场隆重举行。
            ---中国人民抗日战争是世界反法西斯战争的重要组成部分，中国作为世界反法西斯战争东方主战场，开始时间最早、持续时间最长，为世界反法西斯战争的胜利作出了重要历史贡献。
            ---上海超导组织全体员工共同观看大会直播，一起回顾那段波澜壮阔的抗战历史，汲取奋进力量。通过观看阅兵仪式，员工们不仅深刻认识到和平的来之不易，也真切感受到国家现如今的繁荣昌盛。大家纷纷表示，未来将以更饱满的热情投入工作中，立足岗位，努力拼搏，为企业发展和社会进步贡献自己的力量。`,
          other: {
            picture1: { url: "/images/news/93阅兵1.jpg" },
            picture2: { url: "/images/news/93阅兵2.jpg" },
            picture3: { url: "/images/news/93阅兵3.jpg" },
          },
        },
        {
          id: "xinwen2",
          title: "安徽省科技厅领导调研上海超导子公司",
          image: "/images/news/赵明赴合肥市专题调研超导产业发展-头图02.png",
          url: "/news/xinwen2",
          date: "2025-08-26",
          onlyInChinese: true,
          content: `8月26日下午，安徽省科技厅厅长赵明率队赴合肥市专题调研超导产业发展，并与合肥国际应用超导中心执行院长刘华军及相关企业负责人座谈交流。厅平台处、重大处、办公室及合肥市科技局相关负责人参加。
            ---赵明一行先后实地调研了合肥上超材料科技有限公司、合肥核聚磁体科技有限公司、合肥国际应用超导中心等，深入超导中心实验试制场地，参观CORC电缆和REBCO高温超导磁体研制现场，详细了解电缆、磁体制造平台相关情况。座谈会上，赵明听取了国内外超导产业发展现状、安徽省超导产业发展基础以及安徽省应用超导产业创新研究院筹建等情况介绍，并与大家就超导产业相关技术、应用过程中存在的问题和研究院组建等进行了深入交流。
            ---赵明对安徽省超导产业发展取得的成效表示充分肯定。她指出，省委省政府始终高度重视超导产业等未来产业培育发展，要进一步提高站位，围绕加快培育发展新质生产力，充分发挥安徽在超导领域的先发优势，抢抓超导产业发展重要机遇，加强省市联动、通力协作，加快高能级创新平台建设，探索市场化运营模式，大力引进高层次科技人才，持续扩大对外开放合作，产出一批标志性成果，提升超导产业领域话语权，有序推进超导技术向更多行业领域应用拓展，促进科技创新和产业创新深度融合发展，为安徽省打造科技创新策源地、产业创新高地作出更大贡献。`,
          other: {
            picture1: {
              url: "/images/news/赵明赴合肥市专题调研超导产业发展-头图02.png",
            },
          },
        },
        {
          id: "bingliandiankangqi",
          title:
            "高温超导并联电抗器顺利通过型式试验！上海超导持续助力超导应用创新发展",
          image: "/images/news/上海超导持续助力超导应用创新发展1.png",
          url: "/news/bingliandiankangqi",
          date: "2025-07-31",
          content: `近日，由国网上海电力公司牵头，上海翌曦科技主承接研发的10kV/1Mvar高温超导并联电抗器顺利通过型式试验，该项目为全球首台环形超导电抗器，10千伏电压等级，设计容量为1Mvar，是我国在超导电力设备领域的最新研发成果之一，将在上海市徐汇中心城区投入运行。上海超导与翌曦科技紧密合作，作为该项目超导材料核心供应商，上海超导供应了项目所需的全部高温超导带材，为项目的顺利进行提供了高质量的材料支撑。
            ---电抗器是保障电网安全稳定运行的核心设备，传统电抗器存在体积大、损耗高、噪声污染等痛点。此次研发的高温超导并联电抗器具有功率密度高、损耗低、运行噪声低（<60dB）、占地面积小（<8m2）等优势，综合性能指标国际领先，适用于城市密集区域的旧站改造和加装，可有效解决无功补偿难题，进一步提升电网效率和稳定性。
            ---未来，上海超导将继续与客户紧密合作，持续推进超导带材及磁体技术的创新研发和技术攻关，助力更多高温超导应用的建造和创新发展。`,
          other: {
            picture1: {
              url: "/images/news/上海超导持续助力超导应用创新发展1.png",
            },
            picture2: {
              url: "/images/news/上海超导持续助力超导应用创新发展2.png",
            },
          },
        },
        {
          id: "quanqiushiye",
          title: "全球视野·上海机遇！上海超导参加2025上海全球投资促进大会",
          image:
            "/images/news/全球视野·上海机遇！上海超导参加2025上海全球投资促进大会.jpg",
          url: "/news/quanqiushiye",
          date: "2025-03-25",
          content: `3月25日，2025上海全球投资促进大会暨"投资上海"活动周正式开幕。大会以"全球视野·上海机遇"为主题，面向全球企业家和投资者推介上海，共享发展新机遇，共绘开放合作新图景。
            ---会上，21个重点产业项目落地启动，涵盖先进材料、集成电路、数字经济等产业领域。其中，上海超导的"超导二代高温超导带材生产及总部基地项目"落地浦东新区，建设全球首个大工业化级别第二代高温超导带材生产研发基地，承担第二代高温超导带材的生产功能以及产品研发、产线研发、应用研发等功能，建成后总年产能将超15000公里，占据全球细分领域绝对领先地位 。

            ---上海具有全球最完备的高温超导产业链，落地了高温超导可控核聚变、超导电缆等项目，上海超导作为未来战略产业的材料底座，可以快速适配大订单的需求，这是上海独有的优势。浦东一直以来都是创新与开放的高地，优越的营商环境是上海超导坚定选择在浦东布局全球领先的超导带材生产基地的关键因素。上海超导将以此次项目落地为契机，持续强化核心研发能力，深耕技术创新与突破，不断推动我国在高温超导关键材料领域的自主可控和产业化进程。同时，公司也将积极把握上海和中国的发展机遇，加强与全球合作伙伴的交流与合作，共同推动高温超导产业的繁荣发展。`,
          other: {
            picture1: {
              url: "/images/news/全球视野·上海机遇！上海超导参加2025上海全球投资促进大会.jpg",
            },
          },
        },
        {
          id: "guidanjinshenzhang",
          title: "高温超导磁控硅单晶生长技术成功通过专业鉴定",
          image: "/images/news/高温超导磁控硅单晶生长技术成功通过专业鉴定1.jpg",
          url: "/news/guidanjinshenzhang",
          date: "2025-03-18",
          content: `近日，高温超导磁控硅单晶生长技术成功通过专业鉴定。本次鉴定会由中国电工技术学会主持、宁夏超导泛半导体科技有限责任公司牵头组织。会上，由中国科学院院士甘子钊领衔的专家委员会对项目展开全面评估，并一致认为该技术填补了我国在高端硅晶体制造领域的多项空白，综合性能达到国际领先水平。
            ---自2021年起，上海超导与联创超导建立了紧密合作关系，共同推动超导技术的创新与应用。作为联创超导的核心材料供应商，上海超导已为其供应了1000多公里高性能高温超导带材，应用于绕制高温超导感应加热装置和高温超导磁控硅单晶生长装备的超导磁体，为项目的成功实施奠定了坚实的材料基础。

            ---此次科技成果鉴定会的成功举办，标志着我国在超导技术产业化应用领域迈出里程碑式一步，是对联创超导科研团队的技术肯定，也是对上海超导与联创超导紧密合作、大批量稳定供货的认可。上海超导将继续坚持技术创新，发挥批量供货能力优势，与客户共同推动超导技术在更多领域的应用和发展。`,
          other: {
            picture1: {
              url: "/images/news/高温超导磁控硅单晶生长技术成功通过专业鉴定1.jpg",
            },
            picture2: {
              url: "/images/news/高温超导磁控硅单晶生长技术成功通过专业鉴定2.jpg",
            },
          },
        },
        {
          id: "relieqingzhu",
          title:
            "热烈祝贺能量奇点创高温超导磁体新纪录，上海超导供应数百公里高温超导带材",
          image: "/images/news/热烈祝贺能量奇点创高温超导磁体新纪录1.jpg",
          url: "/news/relieqingzhu",
          date: "2025-03-11",
          content: `近日，能量奇点在高温超导磁体领域取得重大突破，其自主研制的大孔径强场磁体——经天磁体成功完成首轮通流实验，产生高达21.7特斯拉的磁场，创下大孔径高温超导D形磁体最高磁场纪录。这一场强超过了美国麻省理工学院和CFS公司联合研制的SPARC TFMC磁体在2021年创造的20.1特斯拉的纪录，标志着能量奇点在高温超导聚变磁体领域达到国际领先水平。
            ---自2022年起，上海超导与能量奇点建立了紧密合作关系。作为能量奇点的核心材料供应商，上海超导为经天磁体提供了数百公里高性能超导带材，为项目的顺利进行提供了坚实的材料支撑。经天磁体是能量奇点继洪荒70后的第二个关键里程牌，洪荒70是全球首台全高温超导托卡马克，值得一提的是，此前上海超导已为洪荒70供应全部所需的高性能高温超导带材。

            ---经天磁体的成功通流，使能量奇点站在了先进磁体技术和聚变能源商业化发展的最前沿，为其下一代托卡马克装置洪荒170的TF磁体关键技术和制造工艺提供了研发和验证基础，同时也再一次展现了上海超导面向聚变磁体等应用的大批量稳定供货能力和产品性能优势。未来，上海超导将继续坚持技术创新，进一步提升供货能力和产品性能，与客户共同推进聚变能源等超导应用技术的突破和发展。`,
          other: {
            picture1: {
              url: "/images/news/热烈祝贺能量奇点创高温超导磁体新纪录1.jpg",
            },
            picture2: {
              url: "/images/news/热烈祝贺能量奇点创高温超导磁体新纪录2.png",
            },
            picture3: {
              url: "/images/news/热烈祝贺能量奇点创高温超导磁体新纪录3.png",
            },
          },
        },
        {
          id: "supergrid",
          title:
            "热烈祝贺SuperGrid Institute成功验证超导限流器新技术方案，上海超导供应全部高温超导带材",
          image:
            "/images/news/热烈祝贺SuperGrid Institute成功验证超导限流器新技术方案1.jpg",
          url: "/news/SuperGrid",
          date: "2025-03-10",
          content: `2024年12月，法国SuperGrid Institute宣布了一项重要技术突破：通过电阻式超导限流器与直流断路器相结合的技术方案，成功实现了50kV直流分断，验证了该方案的技术可行性。这一创新方案不仅有望将地面直流保护设备的尺寸减小40-50%，而且可适用于交流、直流工况，在海上电力系统应用领域展现出显著优势。
            ---自2023年起，上海超导与SuperGrid Institute建立了紧密合作关系，在此次项目中，上海超导提供了数公里的高性能高温超导带材，为项目的成功实施奠定了坚实的材料支持。

            ---SuperGrid Institute的这一技术突破，不仅标志着其超导技术在高压直流系统应用领域的又一重要进展，也彰显了上海超导的高温超导材料在助力超导限流器国际项目上的卓越实力。未来，上海超导将继续聚焦用户需求，坚持技术创新、追求卓越品质，持续优化超导带材性能及相关服务，进一步提升供货能力，与用户协同推动超导应用的发展。
            ---来源：https://www.supergrid-institute.com/2025/01/20/supergrid-institute-first-50kv-dc-breaking-combining-superconducting-fault-current-limiter-circuit-breaker/`,
          other: {
            picture1: {
              url: "/images/news/热烈祝贺SuperGrid Institute成功验证超导限流器新技术方案1.jpg",
            },
            picture2: {
              url: "/images/news/热烈祝贺SuperGrid Institute成功验证超导限流器新技术方案2.jpg",
            },
            picture3: {
              url: "/images/news/热烈祝贺SuperGrid Institute成功验证超导限流器新技术方案3.jpg",
            },
          },
        },
        {
          id: "chuangxinxingqiyezongbu",
          title: "喜讯！上海超导荣获'上海市创新型企业总部'称号",
          image: "/images/news/上海市创新型企业总部2.jpg",
          url: "/news/chuangxinxingqiyezongbu",
          date: "2025-02-28",
          content: `2月27日，第二批上海市创新型企业总部授牌仪式举行，市委副书记、市长龚正为49家创新型企业总部现场授牌，市委常委、常务副市长吴伟宣读认定企业名单，上海超导荣获"上海市创新型企业总部"称号。
            ---2023年2月，上海市首次提出"创新型企业总部"概念，发布了《上海市创新型企业总部认定和奖励管理办法》，对创新型企业总部的认定、奖励、服务与便利化措施等内容作出了具体规定，为优化创新型企业在沪发展营商环境提供了政策支撑。2023年12月5日，第一批40家企业授牌。
            ---荣获"创新型企业总部"的企业，整体聚集在战略性新兴产业重点领域，自主拥有国内外影响力产品或服务的核心知识产权，技术水平和创新能力居于行业领先地位，在市场竞争中具有重要优势和高成长发展能力，是对地方经济社会发展有重要贡献度或具有龙头带动作用等的行业领军企业。
            ---本次活动共有49 家"创新型企业总部"获得授牌，涵盖集成电路、生物医药、人工智能、数字经济、战新综合五大重点产业领域。上海超导作为战新综合领域的代表企业，凭借在超导材料领域的深厚技术积累与持续创新，成功入选。上海超导自主研发的第二代高温超导带材性能处于行业领先水平，生产及总部基地的建设进一步提升了批量供货能力，为超导应用的高质量发展提供了有力的材料支撑。
            ---上海超导的成功入选，不仅是对公司持续创新的鼓励，也是对公司在做强材料的基础上，加强产业链上下游做深化创新的政策驱动，公司将继续快速推动高温超导行业应用的拓展，为上海创新型经济发展贡献力量。`,
          other: {
            picture1: { url: "/images/news/上海市创新型企业总部1.gif" },
            picture2: { url: "/images/news/上海市创新型企业总部2.jpg" },
          },
        },
        {
          id: "shanghaiguotou",
          title: "上海国投公司一行莅临上海超导参观交流",
          image: "/images/news/上海国投公司一行莅临上海超导参观交流.png",
          url: "/news/shanghaiguotou",
          date: "2025-02-13",
          content: `2月13日下午，上海国投公司党委书记、董事长袁国华率队赴上海超导科技股份有限公司（以下简称"上海超导"），实地考察企业技术研发与产业化成果，并就高温超导材料未来发展方向及战略合作展开深度交流。上海超导董事长马韬，总经理朱佳敏，副董事长洪智勇陪同参观并详细介绍了公司技术突破、产业布局及全球竞争规划。
            ---袁国华一行首先参观了上海超导展示厅，全面了解企业自2011年科研成果转化以来的14年发展历程。作为中国首家实现二代高温超导材料规模化量产的企业，上海超导已深度参与国家重大科技专项，其产品在核聚变、超导电缆、高磁场科学装置、超高速磁悬浮列车等领域的应用前景备受瞩目。在生产线及新设备研发中心，袁国华重点关注了企业核心装备国产化突破，特别是泛半导体领域技术赋能的创新成果。他对上海超导在工艺研发、进口替代及上下游技术整合上的领先地位给予高度评价。
            ---座谈会上，马韬系统阐述了上海超导的技术路径与发展蓝图：从实验室成果产业化，到打破国际垄断、跃居全球产能第一，再到向"市占率与经营效率双提升"的阶段迈进。他表示，公司已与全球顶尖机构建立战略合作，覆盖超导电缆、电网保护、磁悬浮交通等多元化场景，正加速推进上市进程。
            ---袁国华高度肯定了上海超导的行业地位。他表示，上海超导不仅是高科技材料企业，更是平台型企业。上海国投公司旗下基金与科创资源，将全力支持企业在技术创新、装备研发及市场应用等领域的突破，并协同政府与产业资本，加速超导技术从实验室到商业化的"最后一公里"跨越。
            ---上海科创集团、国投赋能、国投未来、科创产业研究院等相关负责人参加座谈。`,
          other: {
            picture1: {
              url: "/images/news/上海国投公司一行莅临上海超导参观交流.png",
            },
          },
        },
        {
          id: "niandupandian",
          title: "上海超导入选上海市经信委2024年先进材料领域十件大事年度盘点",
          image:
            "/images/news/上海超导入选上海市经信委2024年先进材料领域十件大事年度盘点2.png",
          url: "/news/niandupandian",
          date: "2025-01-20",
          content: `近日，上海经信委发布2024年度上海先进材料领域十件大事。其中，上海超导凭借能量奇点"洪荒70"的成功供货案例，入选该榜单。
          ---上海超导凭借强大的批量供货能力和优异的产品性能，在洪荒70项目中确保了数百公里带材的高质量、高效率交付，为洪荒70装置的顺利建成提供了坚实的材料基础，也展现了上海超导在加强超导材料的工艺研发、复杂工程应用的应对以及支持上海市先进材料领域创新发展方面的能力和担当。
          ---此次入选上海经信委发布的2024年度先进材料领域十件大事，是对上海超导在超导材料领域持续创新和不懈努力的肯定。未来，上海超导将继续致力于超导材料的研发与应用，为推动上海市乃至全国的先进材料产业发展做出更大的贡献。`,
          other: {
            picture1: {
              url: "/images/news/上海超导入选上海市经信委2024年先进材料领域十件大事年度盘点1.png",
            },
            picture2: {
              url: "/images/news/上海超导入选上海市经信委2024年先进材料领域十件大事年度盘点2.png",
            },
          },
        },
        {
          id: "zhuzhongshentaipeiyang",
          title: "注重生态培育 链式推动高温超导产业发展",
          image: "/images/news/注重生态培育 链式推动高温超导产业发展.jpg",
          url: "/news/zhuzhongshentaipeiyang",
          date: "2024-01-09",
          content: `1月8日下午，市经济信息化委主任张英带队调研上海超导科技股份有限公司（以下简称"上海超导"），实地察看公司展厅与生产车间，并围绕公司发展、产业链对接、产业生态培育等方面开展座谈交流。
          ---张英认真听取了上海超导关于公司经营情况、战略规划的介绍，回应了企业的诉求，围绕产业发展方向、应用场景探索、产业生态培育等方面与企业开展深入探讨。
          ---张英指出，高温超导是全球竞相布局的前沿技术，在输配电、核聚变等领域有巨大的潜在应用价值，在本市相关部门支持下，上海超导已成长为全球领先的高温超导带材供应商。市经济信息化委将持续做好服务工作，支持企业在沪发展，聚焦链式发展，围绕行业发展趋势推动产业链上下游协同；聚焦应用验证，围绕场景挖掘打造高温超导试验场；聚焦生态培育，围绕能源装备等谋划高温超导产业布局。
          ---市经济信息化委办公室、新材料处、产业园区和结构调整处，浦东新区科经委，张江管理局相关负责同志参加调研。
          ---来源：https://mp.weixin.qq.com/s/YC9U0uGa3tEOFtNLfUUPQA`,
          other: {
            picture1: {
              url: "/images/news/注重生态培育 链式推动高温超导产业发展.jpg",
            },
          },
        },
        {
          id: "naixinziben",
          title:
            '上海超导作为全国耐心资本被投典型案例入选"2024央视财经金融强国年度盛典"本年度全国案例',
          image: "/images/news/上海超导作为全国耐心资本被投典型案例入选1.png",
          url: "/news/naixinziben",
          date: "2024-12-26",
          content: `近日，中央广播电视总台"2024央视财经金融强国年度盛典"在北京成功举办，活动以"金融赋能高质量发展"为引领，围绕金融"五篇大文章"、壮大耐心资本、深化金融体制改革、金融高水平开放等四大主题，现场揭晓15个"金融强国年度案例"。其中，[[highlight]]上海科技创业投资（集团）有限公司（以下简称"上海科创集团"）借其投资上海超导等企业的案例，成功入选本年度"耐心资本"案例。[[/highlight]]
          ---"如果没有人去做这个事情……"上海科创投集团党委副书记、总裁朱民很坦诚地表达了：必须有人提前承担为科技创新铺垫坚实基础的任务。
          ---上海科创投秉持"投早投小投长期投硬科技"核心理念，早在2014年就给予了上海超导关键性的资金支持，帮助公司度过初创期的艰难阶段，并最终实现技术突破和市场拓展。目前，上海超导在国内市场占有率80%以上，是多项"全球首个"超导应用项目的核心供应商及独家供货商，年产量与销量均已超过千公里，下游涵盖可控核聚变、超导电力、高场磁体等多个尖端应用领域。
          ---此次盛典上，不仅是对上海科创投投资策略及其在推动国家科技创新和产业升级中所做贡献的肯定，也是对上海超导企业发展、超导产品及其推广应用的认可。展望未来，上海超导将继续深耕超导材料的研发与创新，努力成长为全球超导领域的领跑者，为新材料创新与产业升级贡献力量。`,
          other: {
            picture1: {
              url: "/images/news/上海超导作为全国耐心资本被投典型案例入选1.png",
            },
            picture2: {
              url: "/images/news/上海超导作为全国耐心资本被投典型案例入选2.png",
            },
            picture3: {
              url: "/images/news/上海超导作为全国耐心资本被投典型案例入选3.png",
            },
            picture4: {
              url: "/images/news/上海超导作为全国耐心资本被投典型案例入选4.png",
            },
          },
        },
        {
          id: "xinchailiao",
          title:
            "构建更多新材料的应用场景，上海市政协经济与金融委员会赴上海超导走访调研",
          image: "/images/news/构建更多新材料的应用场景1.jpg",
          url: "/news/xinchailiao",
          date: "2024-12-05",
          content: `12月4日，上海市政协副主席肖贵玉率经济与金融委员会赴上海超导科技股份有限公司走访调研，实地考察公司展厅、前道工艺和后道检测现场，并座谈交流。
          ---上海超导科技股份有限公司的主营业务为第二代高温超导带材的研发设计、生产和销售，是超导产业的链主企业。高温超导材料具备"零电阻"与"完全抗磁性"两大特性，在电力、环保、医疗、国防、交通和大科学装置等领域有重要应用价值。考察过程中，委员们对各种技术细节详细了解的同时也对其后续发展表现出强烈关注：下一代技术提升点是什么？产能规模何时形成？双方交流的热烈气氛自展厅一直延续到座谈会场。
          ---上海超导董事长马韬表示，公司将继续钻研工艺，通过提升电流量加强性能，着手打造高温超导上下游产业集群，带动我国超导产业高质量发展。"目前我国高温超导带材的产业化技术在全球范围内有强劲的竞争力。为了尽快在上海扩展，我们正积极与地方政府探讨拿地协商、工业上楼等各种方案。"马韬迫切希望政协能帮助呼吁，对已经具备产业化条件的企业保障相应生产要素的支持。
          ---座谈交流中，肖贵玉表示，新材料是战略性、基础性产业，也是高技术竞争的关键领域。近年来，高温超导产业在中国蓬勃发展，高温超导带材是国家明确发展的前沿材料，既能加快可控核聚变的工程化进程，又能满足城市电网等刚性用电需求，为提升城市环境品质提供新的解决方案。他说，为抢占未来材料发展前沿，支撑推进新型工业化，培育壮大新质生产力，上海超导要加快构建高温超导材料的应用场景，锚定未来全球市场谋发展。
          ---市政协经济金融委主任严旭主持座谈会。
          ---本文转自微信公众号"政协联线"，作者：政协联线记者 施丹璐。`,
          other: {
            picture1: {
              url: "/images/news/构建更多新材料的应用场景1.jpg",
            },
            picture2: {
              url: "/images/news/构建更多新材料的应用场景2.jpg",
            },
            picture3: {
              url: "/images/news/构建更多新材料的应用场景3.jpg",
            },
          },
        },
        {
          id: "rongyuzizhi",
          title: "喜报！上海超导荣获多项国家级和市级荣誉资质认定！",
          image: "/images/news/喜报.jpg",
          url: "/news/rongyuzizhi",
          date: "2024-09-19",
          content: `近期，上海超导在科技创新与产业发展领域取得了显著成就，接连荣获了包括[[highlight]]上海市市级企业技术中心认定[[/highlight]]、[[highlight]]上海市高温超导材料与应用技术重点实验室"良好"等级评价[[/highlight]]、[[highlight]]成功通过工信部第三批专精特新"小巨人"企业复核等多项重要的国家级、市级荣誉和资质认定[[/highlight]]。这些荣誉不仅彰显了上海超导在超导材料领域的深厚实力、突出业绩及官方认可，更为公司未来的科研创新、技术升级及市场拓展注入更多动力。
          ---**01. 荣膺上海市企业技术中心认定**
          ---近日，上海市经济和信息化委员会公布了2024年度上半年（第32批）上海市市级企业技术中心认定名单，上海超导凭借其卓越的技术创新能力、显著的行业影响力以及在产品研发、成果转化等方面的突出表现，成功获得认定。
          ---上海市市级企业技术中心认定旨在贯彻实施创新驱动发展战略，强化企业技术创新的主体地位，鼓励和支持企业建设高水平的技术中心，是对技术创新能力较强、创新业绩成效显著、具有重要示范和导向作用的企业予以的权威认定。此次获评，标志着上海市经信委对上海超导在公司资质、技术创新实力、产品与服务等方面的权威认可，也是对公司研发团队建设、技术开发能力及创新潜力的高度肯定。
          ---**02. 上海市高温超导材料与应用技术重点实验室通过评估、获评"良好"**
          ---近日，上海市科学技术委员会正式公布关于材料与综合交叉领域上海市重点实验室2018-2022年的发展建设情况的评估结果，上海超导下设的上海市高温超导材料与应用技术重点实验室，凭借其在高温超导材料领域的深厚积累、技术创新及成果转化能力，成功通过评估，荣获"良好"等级评价。
          ---上海市高温超导材料与应用技术重点实验室是上海市首批依托民营企业建设的市级重点实验室，在超导材料基础研究与应用领域具有突出优势，于2020年与绿谷制药、联影医疗、微创医疗、复星医药、新阳半导体、盛美半导体、中微半导体、英语流利说、依图科技共10家具备一定条件和行业龙头地位的民营科技企业一同脱颖而出，建设市级重点实验室，引导民营企业组织高水平应用基础研究，推动学科发展，开放共享先进创新资源。
          ---**03. 成功通过工信部第三批专精特新"小巨人"企业复核**
          ---近日，上海市经济和信息化委员会公布了上海市第三批专精特新"小巨人"复核通过企业名单，上海超导凭借其在专业领域内的精细化发展、特色化产品、创新能力及市场竞争力等方面的显著优势，成功通过复核。
          ---上海超导于2021年成功通过工信部第三批专精特新"小巨人"企业认定，专精特新"小巨人"是专精特新企业中的佼佼者，全国中小企业评定工作中最具权威、最高等级的荣誉称号，代表着入选企业在行业中遥遥领先，具有不可替代的核心竞争力。
          ---上海超导近期获得的多项荣誉与资质认定，不仅是对公司过去努力的肯定，更是开启未来新篇章的钥匙，将进一步提升公司在超导行业内的影响力，为推动超导技术的广泛应用与产业升级树立了标杆。上海超导将继续坚持创新驱动发展战略，深化技术研发，加快成果转化，为超导技术进步和应用发展贡献更多"超导力量"。`,
          other: {
            picture1: {
              url: "/images/news/上海超导荣获多项国家级和市级荣誉资质认定1.jpg",
            },
            picture2: {
              url: "/images/news/上海超导荣获多项国家级和市级荣誉资质认定2.jpg",
            },
            picture3: {
              url: "/images/news/上海超导荣获多项国家级和市级荣誉资质认定3.jpg",
            },
            picture4: {
              url: "/images/news/上海超导荣获多项国家级和市级荣誉资质认定4.jpg",
            },
          },
        },
        {
          id: "zhonglianghui",
          title: "近期活动回顾：上海超导参加行业内多个重量级会议",
          image: "/images/news/上海超导参加行业内多个重量级会议4.jpg",
          url: "/news/zhonglianghui",
          date: "2024-09-14",
          content: `近期，上海超导受邀参加行业内多个重量级会议，包括第11届中国核学会辐照效应分会2024年度学术年会、第二十三次"实用化高温超导材料产学研合作组"暨中国科学院B类先导专项"下一代高场超导磁体关键科学与技术"共同例会和2024年国际应用超导会议（Applied Superconductivity Conference, ASC 2024），通过会议报告、展台展示等多种形式，上海超导积极与行业内众多专家、学者、客户交流，共同探讨高温超导材料发展趋势及应用推广。
          ---[[highlight]]01. 第11届中国核学会辐照效应分会2024年度学术年会[[/highlight]]
          ---8月21日-23日，中国核学会辐照效应分会第二次全国会员代表大会暨2024年度学术年会在西安召开，会议以"迈向更多应用场景的燃料及材料辐照效应研究"为主题，邀请了多位院士和国内外科研院所、高校、企业的300余名科技工作者参加本次会议。
          ---中国核学会辐照效应分会学术年会是核燃料及材料辐照效应领域极具影响力的盛会，上海超导有幸参加本次会议，学习了反应堆关键材料辐照效应及现阶段主流研究方向，更与多位学者探讨超导材料在辐照下的性能变化、服役性能等。
          ---[[highlight]]02. 第二十三次"实用化高温超导材料产学研合作组"暨中国科学院B类先导专项"下一代高场超导磁体关键科学与技术"共同例会[[/highlight]]
          ---8月31日-9月1日，第二十三次"实用化高温超导材料产学研合作组"暨中国科学院B类先导专项"下一代高场超导磁体关键科学与技术"共同例会在济南召开，多位院士及高校科研院所的学术骨干近百人参加本次会议，会议内容主要是B类先导专项"下一代高场超导磁体关键科学与技术"和"实用化高温超导材料产学研合作组"的近期进展及各项目最新进展等。
          ---上海超导有幸受邀参加本次会议，与参会专家和学者交流上海超导的研发进展、稳定量产及供货情况、全面扩产计划进度等。
          ---[[highlight]]03. 2024年国际应用超导会议（Applied Superconductivity Conference, ASC 2024）[[/highlight]]
          ---2024年9月1日，2024年国际应用超导会议（Applied Superconductivity Conference, ASC 2024）在美国盐湖城顺利召开，会议分为超导电子学、超导材料、超导应用等三大部分，聚焦于超导磁体、超导电缆、高能物理、核聚变、生命医疗和能源交通等领域的大规模应用探索，及超导材料的制备、表征、工业化生产的进展。ASC会议是全球规模最大和最具有权威性的应用超导盛会之一，汇聚了全球顶级的超导专家和学者。
          ---上海超导有幸受邀参展本次会议，总裁朱佳敏博士作了口头报告，宣布了上海超导2,000km年产量的达产成功和未来领跑计划，并着重介绍了上海超导的最新研究成果和技术创新。他强调，上海超导的核心竞争力在于独特的技术工艺、高效的生产能力及对超导应用的技术服务和积累的项目经验。
          ---同时，在上海超导展位上也展出了全面扩产的进展成果、完备的质量控制体系及已参与的多个超导应用示范工程的带材使用情况。
          ---未来，上海超导将继续优化超导材料的研发与生产，拓展应用领域，以更优质的产品与服务，为超导可控核聚变、超导电力、超导磁体等应用与发展提供助力。`,
          other: {
            picture1: {
              url: "/images/news/上海超导参加行业内多个重量级会议1.jpg",
            },
            picture2: {
              url: "/images/news/上海超导参加行业内多个重量级会议2.jpg",
            },
            picture3: {
              url: "/images/news/上海超导参加行业内多个重量级会议3.jpg",
            },
            picture4: {
              url: "/images/news/上海超导参加行业内多个重量级会议4.jpg",
            },
          },
        },
        {
          id: "guangdongdianwang",
          title: "广东电网电科院领导一行莅临上海超导进行调研交流活动",
          image:
            "/images/news/广东电网电科院领导一行莅临上海超导进行调研交流活动1.jpg",
          url: "/news/guangdongdianwang",
          date: "2024-08-29",
          content: `8月29日，广东电网电科院党委书记兼副院长王中奥、副总工程师谢松瑜、副总工程师梁晓兵等领导及专家团队莅临上海超导公司，进行了全面而深入的调研与交流活动。我司董事长马韬先生及副董事长洪智勇博士亲自陪同了此次调研，双方就国家重点项目的研究成果、超导材料的现状及其发展趋势进行了广泛而深入的探讨。
          ---来宾们参观了上海超导的生产和检测车间，实地考察了超导材料的生产流程及严格的质量控制体系。特别重点展示了上海超导在第二代高温超导带材量产和批量供应方面的技术实力，以及在超导电力和高场磁体等前沿领域的创新成果和实际应用案例。此外，双方还就多个全球超导电缆项目的进展，进行了深入的交流和讨论。
          ---广东电网电科院的领导和专家们详细介绍了电网应用领域的最新研究动向，对上海超导在推动超导电缆和可控核聚变等重大示范工程中所发挥的积极作用表示了肯定和支持。他们期望未来能与上海超导进一步深化合作，共同推进更多超导技术应用项目的实施，为我国能源科技的进步贡献更多力量。
          ---广东电网电科院近年来不断推动超导技术的应用，并在超导电力技术的研发与应用方面发挥了引领作用。近期，该院不仅成功承担了科技部的国家重点专项超导储能项目，还顺利启动了高温超导直流电缆的示范应用项目，展现了其在该领域的雄厚实力和深远影响。`,
          other: {
            picture1: {
              url: "/images/news/广东电网电科院领导一行莅临上海超导进行调研交流活动1.jpg",
            },
            picture2: {
              url: "/images/news/广东电网电科院领导一行莅临上海超导进行调研交流活动2.jpg",
            },
          },
        },
        {
          id: "nengliangqidian",
          title: "热烈祝贺能量奇点洪荒70成功放电，上海超导供应全部高温超导带材",
          image: "/images/news/热烈祝贺能量奇点洪荒70成功放电1.jpg",
          url: "/news/nengliangqidian",
          date: "2024-06-19",
          content: `近日，能量奇点研发建造的全球首台全高温超导托卡马克——洪荒70成功实现等离子体放电。在惊人的推进效率下，能量奇点迈出了一大步，也是全球商业核聚变公司里程碑意义的一大步。
          ---自2022年起，上海超导和能量奇点建立了紧密的合作关系，共同制定了一套适应核聚变应用的材料供应、验收和质量检验体系，并供应了洪荒70装置从研发、测试到最后整机的全部高温超导带材。上海超导以批量供货能力和产品性能优势，确保了数百公里带材保质保量的交付，为洪荒70装置的顺利建成提供了坚实的材料基础。
          ---在洪荒70建设完成后，上海超导在2023-2024年继续为能量奇点供应数百公里高温超导带材，用于建设其下一个重要里程碑——经天系统。得益于上海超导产能的大幅提升，数百公里的带材在6个月时间内即完成供货。
          ---随着可控核聚变和高温超导技术的持续进步，上海超导也将持续增强批量生产和供货能力，以支持全球可控核聚变领域的创新和突破。上海超导自主研发了具有高工程临界电流密度的高性能高温超导带材，并实现稳定量产，可适用于紧凑型可控核聚变的超导磁体应用。凭借优越的带材性能和稳定的供货能力，上海超导已成功为国内外多个核聚变工程批量供货，主要客户包括美国CFS公司、英国TE公司、能量奇点、中科院合肥等离子体所、星环聚能、西物院585所、Renaissance Fusion等，已应用的聚变类型包括托卡马克、球形托卡马克、仿星器。
          ---全球核聚变市场的快速发展，对第二代超导带材的需求量激增，上海超导在加强研发的基础上推进扩产计划，在产品性能和产能上实现双提升，产能增至2500km/年（4mm宽），在2024年前两季度，月交付量连续稳定超过200km。预计到2024年底，年产能将达到6000km/年。充足的产能可快速响应客户需求、大幅缩短供货周期，为全球高温超导下游客户产品的快速迭代、进一步开拓市场、提升产品竞争力提供坚实助力。
          ---未来，上海超导将继续研发新产品、开拓新需求，培育自身新优势，推进高温超导带材在可控核聚变等应用的突破。`,
          other: {
            picture1: {
              url: "/images/news/热烈祝贺能量奇点洪荒70成功放电1.jpg",
            },
          },
        },
        {
          id: "TFcitai",
          title:
            "热烈祝贺能量奇点首个TF线圈磁体研制完成，将探索聚变能源新纪元，上海超导供应全部高温超导带材",
          image: "/images/news/热烈祝贺能量奇点首个TF线圈磁体研制完成1.jpg",
          url: "/news/TFcitai",
          date: "2023-07-11",
          content: `近日，能量奇点宣布成功绕制洪荒70（HH70）高温超导托卡马克装置的首个环向场线圈（TF）磁体，后续将采用12个尺寸、参数相同的TF磁体共同组成环向磁场。
          ---洪荒70是能量奇点正在研发的全高温超导托卡马克，计划于2023年底建成运行。[[highlight]]上海超导作为能量奇点的核心材料供应商[[/highlight]]，[[highlight]]将为洪荒70装置提供全部所需的高性能超导带材[[/highlight]]。
          ---上海超导与能量奇点紧密合作，建立了良好的合作模式。在疫情期间，上海超导积极调配资源，与能量奇点团结协作、通力合作，共同制定了符合核聚变应用需求的材料供应验收质检体系，保质保量地完成了带材供应。
          ---未来，上海超导将继续致力于自主创新和技术研发，与各方共同推进高温超导技术在聚变能源等领域的应用和发展，争取为全球能源行业的可持续发展贡献力量。`,
          other: {
            picture1: {
              url: "/images/news/热烈祝贺能量奇点首个TF线圈磁体研制完成1.jpg",
            },
            picture2: {
              url: "/images/news/热烈祝贺能量奇点首个TF线圈磁体研制完成2.jpg",
            },
            picture3: {
              url: "/images/news/热烈祝贺能量奇点首个TF线圈磁体研制完成3.jpg",
            },
          },
        },
        {
          id: "shenqichaodao",
          title:
            "“神奇的超导”亮相央视《透视新科技》节目，展示超导应用的创新魅力",
          image: "/images/news/神奇的超导4.png",
          url: "/news/shenqichaodao",
          date: "2023-06-21",
          content: `近日，"奇异的超导材料"亮相CCTV-10频道播出的《透视新科技》，在节目主持人胜春和中科院物理所研究员罗会仟、中科院力学研究所工程师郭亮两位嘉宾的带领下，共同探索超导材料的神奇特性，及国内超导材料的最新应用成果。[[highlight]]节目短片中展示的3个高温超导示范工程项目[[/highlight]]，[[highlight]]全部采用了上海超导提供的高性能超导带材[[/highlight]]，目前两个高温超导电缆示范工程已成功投运、高温超导电动悬浮列车也成功完成首次悬浮运行。
          ---通过这一节目，展示了超导材料的优异特性，在电力、能源、医疗、交通和大科学装置等领域具有广泛应用前景。同时，随着第二代高温超导材料的量产，其在性能和成本方面的优势日益凸显，已成功应用到高温超导电缆、高温超导电动悬浮列车等多个示范工程中。
          ---▶2021年9月，国内首条10千伏三相同轴高温交流超导电缆在深圳投运，开始为深圳标志性建筑平安大厦供电，是全球首个应用于超大型城市中心区的超导电缆，这标志着我国超导电缆开始走入普通百姓生活。
          ---▶2021年12月，国内首条35千伏公里级高温超导电缆示范工程在上海投运，为上海徐汇区4万多户家庭和核心商业街供电，全长1.2km，采用地下铺设，占地面积节省70%，在保障城市用电安全的同时也改善了城市环境。
          ---▶2023年3月，中车长客自主研制的高温超导电动悬浮全要素试验系统完成首次悬浮运行，未来列车时速将达到600公里/时。
          ---上海超导凭借多年研发经验和供货优势，已向国内外多个项目完成超导材料供货，包括可控核聚变、超导电缆、超导限流器、超导感应加热装置、高场磁体等项目。后续上海超导将继续聚焦用户需求，坚持技术创新、追求卓越品质，持续优化超导带材性能及相关服务，与用户协同推动超导应用的发展。`,
          other: {
            picture1: {
              url: "/images/news/神奇的超导1.png",
            },
            picture2: {
              url: "/images/news/神奇的超导2.png",
            },
            picture3: {
              url: "/images/news/神奇的超导3.png",
            },
            picture4: {
              url: "/images/news/神奇的超导4.png",
            },
          },
        },
        {
          id: "ganyingjiare",
          title:
            "世界首台兆瓦级高温超导感应加热装置投用，上海超导供应全部高温超导带材，十年联合攻关推动产业落地",
          image: "/images/news/世界首台兆瓦级高温超导感应加热装置投用1.jpg",
          url: "/news/ganyingjiare",
          date: "2023-04-26",
          content: `4月20日，联创光电超导应用有限公司（下称"联创超导"）自主研制的世界首台兆瓦级高温超导感应加热装置在黑龙江中铝集团东北轻合金公司成功投运。该装置利用高温超导材料在20K温区下实现大口径磁体的超强磁场的特性，可对大尺寸金属工件实现高穿透深度、高能效、高均匀性和温度梯度可控的加热，对超导磁体、旋转加热等核心关键技术的稳定性和可靠性进行了充分验证，标志着我国超导热加工技术率先在全球实现了重大突破，在金属热加工行业实现了颠覆性替代应用。
          ---国内高温超导感应加热技术的研究始于2013年，由联创光电牵头、北京交通大学和上海超导联合攻关，历经十年的技术创新与积累，其中[[highlight]]上海超导作为核心材料供应商[[/highlight]]，[[highlight]]前期研发及该首台兆瓦级高温超导感应加热装置全部使用上海超导的带材产品[[/highlight]]。
          ---联创超导的高温超导感应加热装置，是全球范围内率先实现批量化生产的高温超导产品，联创超导也是全球范围内首个针对单一型号、按月稳定采购定量高温超导带材的企业。目前上海超导已完成供应百公里级别的高温超导带材，根据双方战略合作协议，后续将持续批量供应高性能超导带材，助力金属热加工行业等领域的双碳战略实施。`,
          other: {
            picture1: {
              url: "/images/news/世界首台兆瓦级高温超导感应加热装置投用1.jpg",
              caption: "中央电视台CCTV新闻报道画面",
            },
          },
        },
        {
          id: "zhongchechangkexuanfu",
          title:
            "热烈祝贺中车长客高温超导电动悬浮试验系统完成首次悬浮运行，上海超导供应全部高温超导材料，多年联合攻关助力项目成功！",
          image:
            "/images/news/热烈祝贺中车长客高温超导电动悬浮试验系统完成首次悬浮运行1.png",
          url: "/news/zhongchechangkexuanfu",
          date: "2023-03-31",
          content: `3月31日，中车长客自主研制的国内首套高温超导电动悬浮全要素试验系统在长春完成首次悬浮运行，对高温超导磁体、直线同步牵引等超导电动悬浮交通系统的关键核心技术进行了充分验证，标志着我国在高温超导电动悬浮领域实现重要技术突破，也为推动超导电动悬浮交通系统工程化应用奠定了基础。
          ---该项目由中车长客牵头承担，上海交通大学、上海超导等多家单位参与联合研制，其中[[highlight]]上海超导作为核心材料供应商为该项目提供了全部高性能高温超导材料[[/highlight]]，并在多年的联合攻关团队中，深度参与了车载高温超导磁体等多个关键部件的开发。后续也将跟随由中车牵头的联合团队，在更大尺寸、更高速度的超导电动磁浮样车研制工作中做出贡献。`,
          other: {
            picture1: {
              url: "/images/news/热烈祝贺中车长客高温超导电动悬浮试验系统完成首次悬浮运行1.png",
              caption: "中国首套高温超导电动悬浮全要素试验系统",
            },
          },
        },
        {
          id: "keji35",
          title:
            '最新！上海超导总裁朱佳敏入选《麻省理工科技评论》"35岁以下科技创新35人"中国',
          image: "/images/news/35岁以下科技创新35人1.png",
          url: "/news/keji35",
          date: "2023-03-30",
          content: `3月30日，上海超导科技股份有限公司总裁朱佳敏成功入选《麻省理工科技评论》"35岁以下科技创新35人"中国，并被授予"创业家（Entrepreneurs）"勋章，以表彰其开发高温超导带材、创立上海超导公司，并推广高温超导这项"颠覆式"技术在紧凑型核聚变、超导电力、高场磁体等领域的创新应用。
          ---本次"35岁以下科技创新35人"（35 Innovators Under 35，简称"TR35"）中国榜单的入选者中，33位来自各大知名高校、2位来自高科技企业，涵盖计算机、生物和生命科学、化学、物理、材料、半导体、量子计算等各大领域。朱佳敏是其中唯一一位本土民营企业入选者，这将为超导行业的发展及商业化应用带来更广泛的关注。
          ---_（以下为官方内容）_
          ---**入选理由：[[highlight]]他带领团队开发了高工程临界电流密度的高温超导带材并实现了批量化制备，为可控核聚变工程向紧凑型发展提供了关键的原材料。[[/highlight]]**
          ---朱佳敏作为创始人之一，共同创立了上海超导科技股份有限公司。历经十多年的努力，他带领团队从核心装备国产化、产品工艺质量改进以及实用化技术攻关几个方面，实现了该类高性能超导带材批量化生产。
          ---他研发了完整二代高温超导带材国产化生产线，首次提出了用于脉冲激光沉积设备的非对称辅助加热技术，发明了带材封装中的非接触式强制瞬冷技术，这些技术突破解决了高温超导带材量产化的难题。
          ---朱佳敏还针对超导带材关键性能指标开发了测试平台和方法，建设了完整工艺质量体系。他发明了一种全球电阻最小的二代高温超导带材工业接头并实现了工业生产，解决了带材长度有限问题，攻克了带材过流烧断、浸渍性能退化、不锈钢封装问题等长期困扰业界的难题。
          ---此外，他还开发了面向电力应用的低成本带材结构，和面向紧凑型聚变磁体用的高工程临界电流密度带材结构，解决了高温超导带材实用化的难题，推动了超导强电应用的发展。
          ---目前，朱佳敏带领的上海超导已为全球三个电压等级最高的超导限流器、全球首台兆瓦级感应加热装置、全球磁场最高的全超导稳态强磁体、全球首条 35kV 公里级高温超导电缆等重大工程提供原材料。
          ---特别值得关注的是，朱佳敏开发的高工程临界电流密度REBCO高温超导带材，成为MIT-CFS开发的紧凑型聚变20T磁体的关键原材料。同时，这一紧凑型聚变技术也是《麻省理工科技评论》2021 年"全球十大突破性技术"之一。
          ---在国际16家企业中，上海超导作为目前仅两家做到在30μm薄基带上制备出高Je带材的公司，并作为唯一一家开发出基于25μm薄基带的批量化超导带材，为人类能源的终极梦想又进了一步。`,
          other: {
            picture1: {
              url: "/images/news/35岁以下科技创新35人1.png",
              caption: "朱佳敏总裁入选《麻省理工科技评论》TR35中国",
            },
            picture2: {
              url: "/images/news/35岁以下科技创新35人2.png",
              caption: "《麻省理工科技评论》官方报道",
            },
            picture3: {
              url: "/images/news/35岁以下科技创新35人3.png",
              caption: "全体获奖人员合影",
            },
          },
        },
        {
          id: "guojiadianwang",
          title: "国家电网公司科技创新部前来调研考察",
          image: "/images/news/国家电网公司科技创新部前来调研考察1.png",
          url: "/news/guojiadianwang",
          date: "2023-02-24",
          content: `2月24日，国家电网公司科技创新部许海清副主任、上海交通大学先进产业技术研究院副院长刘欢喜及电气工程系的主要专家学者一行前来上海超导调研考察，公司总裁朱佳敏博士代表公司陪同调研。
          ---朱佳敏总裁带领各位领导和专家实地参观了上海超导的生产线，并详细介绍上海超导在第二代高温超导带材研发、产线建设、超导电力和可控核聚变等应用的推广与创新等方面的工作进展。
          ---许海清副主任对上海超导的工作进展表示充分肯定。他指出，上海超导为超导应用的推广做出了积极贡献，希望继续发挥自身优势，积极参与创新发展工作，助力上海市相关超导应用项目的落地落实。`,
          other: {
            picture1: {
              url: "/images/news/国家电网公司科技创新部前来调研考察1.png",
              caption: "各位领导和专家参观上海超导生产线",
            },
            picture2: {
              url: "/images/news/国家电网公司科技创新部前来调研考察2.png",
              caption: "各位领导和专家参观上海超导生产线",
            },
          },
        },
        {
          id: "lanzhoudaxue",
          title: "上海超导与兰州大学签署产学研合作协议",
          image: "/images/news/上海超导与兰州大学签署产学研合作协议1.jpg",
          url: "/news/lanzhoudaxue",
          date: "2022-10-01",
          content: `2022年9月28日，上海超导科技股份有限公司（以下简称"上海超导"）与兰州大学产学研合作签约仪式在兰州大学祁连堂举行。兰州大学土木工程与力学学院、超导力学研究院院长周又和院士出席并致辞，兰州大学党委副书记曹爱辉，兰州大学科研院院长王朝平，兰州大学土木工程与力学学院院长黄宁教授、书记李晓莉、副院长王省哲教授，上海超导科技股份有限公司董事长、法人马韬、执行董事洪智勇、总裁朱佳敏等参加签约仪式。
          ---签约仪式上，执行董事洪智勇介绍了上海超导的现状及未来发展，目前上海超导已成为国际一流、国内领先的二代高温超导材料供应商，是国内多个重大超导示范工程和国外小型核聚变项目的超导材料供应商，在产品性能和关键技术方面需要高复合人才和技术突破。王省哲教授介绍了超导电磁固体力学实验室近期发展。
          ---随后，总裁朱佳敏、科研院院长王朝平代表双方进行了签约。双方将在二代高温超导材料制备工艺、力学性能提升、多场性能综合表征、高温超导磁体研制等方面进行全面合作，发挥各自优势，促进产学研用深度融合。`,
          other: {
            picture1: {
              url: "/images/news/上海超导与兰州大学签署产学研合作协议1.jpg",
              caption: "签约仪式现场",
            },
          },
        },

        {},
        {
          id: "wuchangxianxue",
          title: "为生命接力、为超导添彩——上海超导组织开展无偿献血活动",
          image: "/images/news/上海超导组织开展无偿献血活动1.png", // Use image 1 as the preview
          url: "/news/wuchangxianxue",
          date: "2021-11-17",
          content: `2021年11月16日，上海超导组织开展"为生命接力、为超导添彩"无偿献血活动，活动有十余人踊跃报名，成功献血6人，献血1200毫升。
          ---上午9点，参加献血的员工早早等在公司楼下，统一出发至浦东新区血液管理中心参加无偿献血。
          ---在医务工作者的指引下，参加献血的员工依次排队登记、验血、采血。在献血者中，有坚持多年无偿献血的"老同志"，也有初次献血的"新朋友"。
          ---为了献血，前一晚还在值班的小郭特地留下来参加献血，献完血后匆匆回家休息。
          ---更多的上超人参加无偿献血后主动回到公司奋战在各自的工作岗位上。
          ---热血有限，真情无价，每一滴血液，都是爱心的传递。近年来，公司几乎每年都会组织无偿献血活动，本次无偿献血活动，旨在发挥公司党员、干部先锋模范作用，彰显上海超导及上超人勇于奉献、敢于担当、热心公益、体现社会责任的初心和使命。`,
          other: {
            picture1: {
              url: "/images/news/上海超导组织开展无偿献血活动1.png",
              caption: "献血活动现场",
            },
            picture2: {
              url: "/images/news/上海超导组织开展无偿献血活动2.png",
              caption: "献血活动现场",
            },
            picture3: {
              url: "/images/news/上海超导组织开展无偿献血活动3.png",
              caption: "献血活动现场",
            },
            picture4: {
              url: "/images/news/上海超导组织开展无偿献血活动4.png",
              caption: "献血活动现场",
            },
            picture5: {
              url: "/images/news/上海超导组织开展无偿献血活动5.png",
              caption: "献血活动现场",
            },
            picture6: {
              url: "/images/news/上海超导组织开展无偿献血活动6.png",
              caption: "献血活动现场",
            },
          },
        },
        {
          id: "shenzhendianlan",
          title:
            "我国首条三相同轴超导电缆在深圳正式投入运行 公司为第二代高温超导带材唯一供应商",
          image: "/images/news/我国首条三相同轴超导电缆在深圳正式投入运行1.jpg", // Placeholder image
          url: "/news/shenzhendianlan",
          date: "2021-09-29",
          content: `2021年9月28日，我国首条自主研制的10KV三相同轴高温超导交流电缆在深圳投入运行。此工程是南方电网公司深圳供电局研制并承担的重大科技专项，为深圳地标性建筑平安大厦等重要用户供电；工程是全球首个应用于高负荷密度供电区域的超导电缆示范工程，标志着我国全面掌握三相同轴超导电缆从设计、制造到建设的全套关键技术。
            ---上海超导为此工程第二代高温超导带材的唯一供应商，并于2021年2月完成供货，为工程的建设和运行打下了坚实的基础。未来，上海超导将继续坚持科技创新理念，不断进行科技攻关，为超导电缆、超导磁悬浮、可控核聚变、超导感应加热、超导限流器、超导电机、超导储能等领域，提供一流的产品和技术服务。`,
          other: {
            picture1: {
              url: "/images/news/我国首条三相同轴超导电缆在深圳正式投入运行1.jpg", // Placeholder
              caption: "公司副总裁洪智勇代表公司参加决赛",
            },
            picture2: {
              url: "/images/news/我国首条三相同轴超导电缆在深圳正式投入运行2.png", // Placeholder
              caption: "颁奖现场",
            },
          },
        },
        {
          id: "chuangkezhongguo",
          title: '公司荣获2021年"创客中国"上海赛区决赛二等奖',
          image: "/images/news/创客中国上海赛区决赛二等奖1.jpg", // Placeholder image 1 for preview
          url: "/news/chuangkezhongguo",
          date: "2021-09-13",
          content: `9月9日，2021年"创客中国"上海市中小企业创新创业大赛决赛在张江举行。今年共有近600个项目报名，334个项目通过海选。最终，包括我司共26家企业进入决赛角逐，参加决赛的企业涵盖人工智能、集成电路、生物医药等多个领域。
          ---上海市经信委副主任戎之勤、上海市科创办执行副主任彭崧等出席活动并致辞。上海股权投资协会张向阳副会长等专家作为评审参加本次大赛。
          ---经过多轮角逐，上海超导凭借卓越的产品力以及优异的科创力在决赛中脱颖而出，获得[[highlight]]上海赛区决赛二等奖[[/highlight]]。
          ---2021年"创客中国"上海市中小企业创新创业大赛暨最具投资潜力50佳创业企业评选及诸神之战上海赛区与独角兽潜力企业评选，是在工业和信息化部、财政部指导下，由上海市经济和信息化委员会、上海市财政局主办，上海市促进中小企业发展协调办公室 、上海市中小企业发展服务中心、上海市投资促进服务中心、上海市国际股权投资基金协会、上海股权投资协会、上海市创业投资行业协会、阿里云创新中心、上海漕河泾新兴技术开发区发展总公司、上海张江高新技术创业服务中心联合承办的精英团队创业企业大赛。`,
          other: {
            picture1: {
              url: "/images/news/创客中国上海赛区决赛二等奖1.jpg", // Placeholder
              caption: "公司副总裁洪智勇代表公司参加决赛",
            },
            picture2: {
              url: "/images/news/创客中国上海赛区决赛二等奖2.png", // Placeholder
              caption: "颁奖现场",
            },
            picture3: {
              url: "/images/news/创客中国上海赛区决赛二等奖3.png", // Placeholder
              caption: "获奖证书",
            },
          },
        },
        {
          id: "zhuanjingtexin",
          title: '公司获上海市"专精特新"企业授牌',
          image: "/images/news/公司获上海市专精特新企业授牌1.png", // Placeholder image
          url: "/news/zhuanjingtexin",
          date: "2021-07-01",
          content: `在党的百年华诞之际，公司荣获上海市"专精特新"企业授牌。引导企业走"专精特新"发展之路,一直是党中央、国务院和上海市委、市政府促进中小企业实现高质量发展的重要举措，培育"专精特新"中小企业，提高中小企业发展质量，是政府《促进中小企业发展十三五规划》、《促进大中小企业融通发展三年行动计划》中多次提及的重要工作。自实施此项培育工程以来，已有一大批标杆企业成长起来，企业规模和效益不断提升，创新力和影响力显著提高。可以说，"专精特新"企业已成为中小企业发展水平的代表。
          ---上海超导是国际上能够批量产出并年销售百公里以上第二代高温超导带材的六家生产商之一，是国际上唯一一家能够实现高温超导全套生产装备和工艺交钥匙工程的公司，也是行业内唯一能在产业链上、中、下游提供优质产品的公司，作为国内超导带材研发及应用技术的先驱者和引领者，上海超导获此殊荣，反映了政府对公司的肯定与认可，公司将不忘初心，继续加强科研创新，努力在世界超导领域的顶峰铭刻属于中国人的光荣！`,
          other: {
            picture1: {
              url: "/images/news/公司获上海市专精特新企业授牌1.png", // Placeholder
            },
          }, // No other images mentioned in the source
        },
        {
          id: "kejiqianding",
          title:
            '上海超导"高温超导带材制备关键技术和产业化"项目通过科技成果鉴定',
          image: "/images/news/高温超导带材制备关键技术和产业化1.jpg", // Placeholder image 1 for preview
          url: "/news/kejiqianding",
          date: "2021-03-27",
          content: `2021年3月27日，"高温超导带材制备关键技术和产业化"项目科技成果鉴定会在上海召开。
          ---本次鉴定会由中国电力企业联合会组织，中国科学院甘子钊院士任主任委员、中国工程院丁文江院士任副主任委员，参加鉴定会的专家组成员还有上海电力大学副校长符杨教授、南京大学闻海虎教授、上海电气科学研究所副总裁吴小东教高、中科院电工研究所古宏伟研究员、国网上海电力公司电力科学研究院副院长黄华教高、同济大学张明锐教授、电子科技大学陶伯万教授。
          ---"高温超导带材制备关键技术和产业化"项目由上海超导科技股份有限公司、上海交通大学共同承担，对高温超导带材制备关键技术及产业化整体目标进行了一系列核心技术研发，突破超薄精密哈氏合金基带和大尺寸超导靶材生产关键技术，解决了国外对高温超导带材制备中原料的"卡脖子"难题，确保了超导产业化供应链的安全可控；开发了具有自主知识产权的镀膜技术及装备，使高温超导带材批量化制备水平获得显著提高；发明了新型封装技术、研发出纳欧级别超导低阻接头，大幅提高了高温超导带材力学和电学性能。
          ---鉴定委员会一致认为，项目基于IBAD+PLD技术路线，形成的"第二代高温超导带材超高速批量化制备技术及装备"总体达到"国际领先水平"，实现了面向不同应用场景的高温超导带材定制化批量生产能力，在电力、工业节能、超导高速磁悬浮列车、紧凑可控核聚变大科学装置等领域得到了广泛应用，经济和社会效益十分显著。
          ---上海超导科技股份有限公司董事长邱炜以及项目组相关人员参加了会议。`,
          other: {
            picture1: {
              url: "/images/news/高温超导带材制备关键技术和产业化1.jpg", // Placeholder
              caption: "验收专家组听取项目验收汇报",
            },
            picture2: {
              url: "/images/news/高温超导带材制备关键技术和产业化2.jpg", // Placeholder
              caption: "验收专家组听取项目验收汇报",
            },
            picture3: {
              url: "/images/news/高温超导带材制备关键技术和产业化3.jpg", // Placeholder
              caption: "公司总裁朱佳敏向专家组介绍高温超导带材性能及检测情况",
            },
          },
        },
        {
          id: "shoucidianlan",
          title: "上海超导成为我国首条高温超导电缆示范工程主要供应商",
          image:
            "/images/news/上海超导成为我国首条高温超导电缆示范工程主要供应商1.png", // User-specified placeholder
          url: "/news/shoucidianlan",
          date: "2019-02-22",
          content: `[[highlight]]2月21日，我国首条公里级高温超导电缆示范工程启动大会在上海宝山城市工业园区举行，标志着我国超导电缆产业化正式起步。上海超导成为该示范工程超导材料主要供应商之一。[[/highlight]]
          ---大会由上海市经信委副主任张建明主持，宝山区区长范少军致欢迎辞，市经信委书记陆晓春和宝山区区委书记汪泓为上海高温超导产业基地揭牌，中国工程院院士黄崇祺就高温超导前沿技术的重要意义发表讲话。
          ---启动大会上，作为示范工程高温超导材料主要供应商，上海超导与国网上海电力公司签订了带材供应合作协议。工程预计2019年底正式挂入上海电网实现运行，连接中心城区的两座变电站。这将是全球范围内首次在超大城市腹地引入超导电缆，它所承载的电流容量也将位列世界第一。
          ---国家电网上海电力公司总工程师谢伟表示，上海超导生产的超导带材，可以取代多根传统的金属电缆。上海高温超导电缆示范项目是电网发展史上具有里程碑意义的事件，对上海这样的城市来说，受制于土地资源，新建输电线路难度很大。超导示范工程如果能成功，进而推广，就可以缓解超大城市用电负荷密集与输电通道狭小之间的矛盾。
          ---2015年，上海超导自主研制的公里级物理法第二代高温超导带材生产线投产，打破国际垄断，将材料应用到我国多个重点工程中，并在2017年实现材料批量出口，目前国际和国内的销售比例各占一半。
          ---上海超导已与国内外100余家高校、科研院所、企业建立合作关系，国内市场占有率约80%，产品已成功应用于国家863计划高温超导限流器、南方电网500kV超导限流器、南方电网电阻型超导直流限流器、上海电气集团高温超导发电机、英国Tokamak能源超导核聚变、美国MIT能源超导核聚变、新西兰RRI超导磁体等国内外示范工程和项目。而今迎来了产业化最为关键的“临门一脚”，电缆示范工程的启动，意味着在高温超导技术产业化方面，上海超导已做好技术、人才、产业等各项准备；随着工程的推进，上海超导将有机会全面参与验证该系统的技术可靠性、稳定性和经济性，积累第一手数据和经验。
          ---随着我国首条公里级高温超导电缆示范项目的启动，上海超导未来将继续加大高温超导产业化的深度布局，进一步与相关科研院、高校共同在超导核聚变、超导限流器、超导磁悬浮、超导储能装置等领域合作并加大研发力度，完善超导产业链，努力成为具有全球影响力的超导企业，打响“上海制造”品牌，助力提升上海科创中心和城市能级的核心竞争力，在新一轮科技革命和产业变革中，抢占科技和经济制高点。`,
          other: {
            // No specific images described in the source text,
            // but we can use the provided name as a placeholder if needed later.
          },
        },
        {
          id: "shanghaichaodaohuiyi",
          title: '公司成功举办"2018上海高温超导会议"',
          image: "/images/news/2018上海高温超导会议1.jpg", // User-specified placeholder
          url: "/news/shanghaichaodaohuiyi",
          date: "2018-08-16",
          content: `2018年8月15日至17日，"2018上海高温超导会议"（Shanghai High-Temperature Superconductor Conference 2018， ShHTS 2018）在上海兴国宾馆举行。会议由上海交通大学（SJTU）、上海超导科技股份有限公司（SST）共同主办，日本低温工学超导学会（CSSJ）协办，会议有国家千人计划获得者、国家杰出青年、美国科学院院士等国内外超导界专家学者及产业界人士近百人参加，共同探讨了高温超导领域的最新研究成果及未来产业化发展方向，并对高温超导产业的长期发展和思路进行了交流。
          ---上海市科委副主任干频和上海交通大学副校长毛军发院士发表了会议致辞。干频高度评价了超导技术对加快建设上海科创中心的积极意义，干频指出上海市科委将一如既往的支持超导领域产学研及产业链上下游协同合作，以公里级高温超导电缆等大型示范工程项目为契机，将超导产业做实、做强，提升上海制造的品牌影响力；毛军发在致辞中表示，上海交大对高温超导领域高度重视，集合了各方面资源建立了上海交通大学超导联合研究院，与上海超导科技股份有限公司形成了良好的互动，未来将与更多国内外单位合作交流，共同推动超导产业的发展；美国国家高场实验室的Larbalestier 教授受邀做了报告，展望了高温超导材料在低温高场磁体中的应用及未来探索方向；广东电网公司科技部主任段新辉在会上作了报告，汇报了近期广东电网的超导电缆、超导限流器等项目进展，及其在未来电网中的应用前景；西北有色金属研究院院长张平祥教授在会上作报告，介绍了国内实用化高温超导材料的研发进展，同时展望了超导材料在高端医疗、低温高场等领域的应用前景，及对新型高温超导材料的研发进展。
          ---近年来，中国在高温超导领域取得了一系列重大突破，REBCO超导材料已逐步成熟并形成稳定化量产，以上海超导科技股份有限公司为代表的企业已实现了生产线核心装备的自主研发及国产自制，以国家电网公司、南方电网公司、中国科学院、航天科工集团、中车集团等企业在超导领域已开展了多个高温超导产品的工业化应用研究、验证。国内高温超导产业链正逐步走向成熟，制冷等配套设备厂家也正在探索国产化，均为高温超导产业的良性发展奠定了重要基础。
          ---上海超导作为国内首家能大规模量产二代高温超导带材的供应商，在高温超导材料应用领域获得了很大进展，已与包括国家电网公司、南方电网公司、航天科工集团、中车集团、中国科学院电工研究所、中国科学院高能物理研究所、核工业集团、东方电气集团在内的十数家科研机构及企业在超导电缆、超导限流器、超导核聚变、粒子加速器、超导磁悬浮、超导磁体等诸多项目进行了合作。上海超导副总裁洪智勇教授表示，本次会议对高温超导产业发展具有重要意义，在上海市政府、上海市科委、上海交通大学以及国内外超导行业的专家和学者的共同推动下，高温超导应用将在中国实现全面开花的局面，高温超导的产业化进程也将大大加快。`,
          other: {
            picture1: {
              url: "/images/news/2018上海高温超导会议1.jpg",
              caption: "2018上海高温超导会议现场",
            },
            picture2: {
              url: "/images/news/2018上海高温超导会议2.jpg",
              caption: "专家出席会议并发表演讲",
            },
            picture3: {
              url: "/images/news/2018上海高温超导会议3.jpg",
              caption: "专家出席会议并发表演讲",
            },
            picture4: {
              url: "/images/news/2018上海高温超导会议4.jpg",
              caption: "专家出席会议并发表演讲",
            },
          },
        },
        {
          id: "yingyongshizhang",
          title: "上海市长应勇等领导来公司考察调研",
          image: "/images/news/上海市长应勇等领导来公司考察调研1.jpg",
          url: "/news/yingyongshizhang",
          date: "2018-08-14",
          content: `8月14日上午9时，市委副书记、市长应勇等领导来公司调研超导技术开发及市场应用转化情况，常务副市长周波、市政府秘书长汤志平、市政府副秘书长马春雷及上海张江综合性国家科学中心办公室常务副主任施尔畏等相关领导陪同调研。公司董事长邱炜、副总裁洪智勇等热情接待了应勇等领导，上海交通大学副校长毛军发、上海交通大学教授金之俭等陪同接待。
          ---应勇市长指出，上海正在加快建设具有全球影响力的科创中心，科创企业发挥着不可或缺的重要作用。上海超导要按照习近平总书记"力争在基础科技领域作出大的创新、在关键核心技术领域取得大的突破"的重要指示要求，面向世界科技前沿、面向国家重大需求、面向国民经济主战场，聚焦主攻方向，协同创新攻坚，力争在超导领域的关键核心技术方面取得重大突破。要深化科技体制机制改革，加快科技成果转移转化，推进产学研用一体化。
          ---应勇市长首先参观了公司展示厅，工作人员向应勇市长汇报了上海超导在第二代高温超导材料、超导自主装备、项目的研发及产业化应用等领域工作的进展情况。随后应勇市长又兴致勃勃的下到公司生产车间，参观了公司自主研发的第二代高温带材生产线，并向材料事业部负责人朱佳敏询问了超导材料的技术研发、生产水平等情况。参观结束后，董事长邱炜向应勇市长汇报了公司在超导领域研发和产业化发展情况，以及公司未来的发展战略，应勇市长对公司的技术成果产业化工作给予了充分肯定，希望公司能坚持产学研相结合，不断提升产品性价比，加快高温超导应用的步伐，走出一条自主创新、自主研发、产业化的新路，推动中国超导产业的发展。
          ---应勇市长高度赞扬了公司在第二代超导技术研发及成果转化方面所取得的成就，并对公司未来的发展寄予了厚望，应勇市长表示，上海将一如既往全力支持科创企业的发展，支持高温超导技术在沪加快发展。希望上海超导能继续抢占超导技术的发展前沿，增强攻坚合力，提高核心技术创新能力，推动更多科技成果转移转化，早日实现超导技术的市场化应用，更好地满足人民群众对高品质生活的需求。`,
          other: {
            picture1: {
              url: "/images/news/上海市长应勇等领导来公司考察调研1.jpg",
            },
            picture2: {
              url: "/images/news/上海市长应勇等领导来公司考察调研2.jpg",
            },
          },
        },
        {
          id: "gongxinbubuzhang",
          title: "工信部副部长一行莅临我司参观考察",
          image: "/images/news/工信部副部长一行莅临我司参观考察1.jpg",
          url: "/news/gongxinbubuzhang",
          date: "2017-03-17",
          content: `2017年3月17日下午，工业和信息化部副部长徐乐江、上海市经济和信息化委员会总工程师原青海等一行莅临上海超导进行参观考察，了解高温超导带材技术成果、超导产业未来推进工作等内容。在上海超导总裁、副总裁及其他工作人员的陪同下，副部长一行参观了上海超导的二代高温超导带材连续生产线以及超导展厅。---参观期间，我司向领导们展示了近几年的研发成果并详细汇报了关于二代高温超导带材的制备过程、具体性能、应用项目以及未来的发展路线。参观完毕，领导对我司的技术成果给予了充分肯定，并希望上海超导能不断提升产品性价比，加快高温超导应用的步伐，从而大力推动中国超导产业的发展。`,
          other: {
            picture1: {
              url: "/images/news/工信部副部长一行莅临我司参观考察1.jpg",
              caption:
                "上海超导副总裁洪智勇博士为徐乐江部长介绍超导无线充电原理",
            },
            picture2: {
              url: "/images/news/工信部副部长一行莅临我司参观考察2.jpg",
              caption: "为领导讲解二代高温超导带材结构及性能",
            },
            picture3: {
              url: "/images/news/工信部副部长一行莅临我司参观考察3.jpg",
              caption: "向领导展示二代高温超导带材生产线",
            },
          },
        },
        {
          id: "babcocknoell",
          title: "德国巴布科克诺尔有限公司磁体部门负责人一行到访上海超导",
          image:
            "/images/news/德国巴布科克诺尔有限公司磁体部门负责人一行到访上海超导1.jpg", // Placeholder image
          url: "/news/babcocknoell",
          date: "2017-03-17",
          content: `2017年3月16日上午，德国巴布科克诺尔有限公司（Babcock Noell GmbH）磁体部门总经理Wolfgang Adolf Walter博士、核技术部门销售和项目工程师李宏友博士以及磁体部门销售总经理Michael Gehring到访上海超导参观考察。参观期间，李宏友博士一行对上海超导的带材性能、生产工艺进行了详细了解；参观完毕，博士一行与上海超导技术人员就高温超导超导磁体的技术问题进行了深入讨论，同时对比了一代高温超导带材和二代高温超导带材各自用作高场磁体的优缺点。博士一行表示未来有望与上海超导合作，将高温超导磁体应用在大型对撞机、粒子加速器等大科学仪器项目中。---德国巴布科克诺尔有限公司（Babcock Noell GmbH）是德国工程服务巨头Bilfinger SE旗下全资子公司，主营业务包括核服务、核技术、磁体技术以及环境技术。二十世纪初，巴布科克诺尔开始研发可应用于高能物理与核聚变的大型超导磁体，目前巴布科克诺尔是大型强子对撞机（LHC）的加速圈磁体供应商之一。`,
          other: {
            picture1: {
              url: "/images/news/德国巴布科克诺尔有限公司磁体部门负责人一行到访上海超导1.jpg",
              caption:
                "上海超导副总裁洪智勇博士为徐乐江部长介绍超导无线充电原理",
            },
            picture2: {
              url: "/images/news/德国巴布科克诺尔有限公司磁体部门负责人一行到访上海超导2.jpg",
              caption: "为领导讲解二代高温超导带材结构及性能",
            },
          },
        },
        {
          id: "lihaichaodao",
          title: "厉害了！我的超导！",
          image: "/images/news/我的超导1.png",
          url: "/news/lihaichaodao",
          date: "2016-11-10",
          content: `一年一度中国装备制造业最具影响力的"中国国际工业博览会"（以下简称"工博会"）于2016年11月1日至5日在上海举行。今天，世界新能源、新材料、信息技术已经进入高速腾飞阶段，超导材料历经百年的技术积淀，也已进入黄金发展时期，超导材料作为革命性的无损通电导体正在改变这个时代。此次工博会上，上海超导同时在4.2H和6.2H两个展馆展出了由上海超导科技有限公司历经数年自主研发制造的第二代高温超导产线展项、二代高温超导带材展项、以及包括超导磁悬浮、超导感应加热设备、超导无线充电装置等在内的超导应用展项，可谓亮点纷呈，备受瞩目。
          ---[[highlight]]关键数字[[/highlight]]
          ---[[highlight]]两个奖项[[/highlight]]
          ---上海超导凭借"二代高温超导交钥匙产线"荣获第18届中国国际工业博览会工业设计金奖。
          ---上海超导的"二代高温超导带材"荣获第十八届中国国际工业博览会新材料产业展参展产品三等奖。
          ---[[highlight]]接待十余位领导[[/highlight]]
          ---展会五天，上海超导两个展台接待了：上海市委副书记，市人民政府市长、党组书记杨雄；曾任第十届全国政协副主席、中国工程院院长、上海市市长，现任中国经济工业联合会会长、上海大学教授、博士生导师的徐匡迪院士；上海交通大学党委书记姜斯宪；上海市政协副主席徐逸波；上海市金山区区委书记，赵卫星；国家工业和信息化部原材料工业司司长周长益等十余位领导。
          ---[[highlight]]二十余家媒体报导[[/highlight]]
          ---[[highlight]]接待千余名观众[[/highlight]]`,
          other: {
            picture1: {
              url: "/images/news/我的超导1.png",
              caption: "上海超导展台",
            },
            picture2: {
              url: "/images/news/我的超导2.png",
              caption: "超导悬浮笔展示",
            },
            picture3: {
              url: "/images/news/我的超导3.png",
              caption: "超导磁悬浮列车模型",
            },
            picture4: {
              url: "/images/news/我的超导4.png",
              caption: "超导磁悬浮演示项目",
            },
            picture5: {
              url: "/images/news/我的超导5.png",
              caption: "超导无线充电",
            },
            picture6: {
              url: "/images/news/我的超导6.png",
            },
            picture7: {
              url: "/images/news/我的超导7.png",
            },
            picture8: {
              url: "/images/news/我的超导8.png",
            },
          },
        },
        {
          id: "ascguoji",
          title: '二代高温超导带材"走出去"的里程碑: 上海超导初登ASC国际舞台',
          image: "/images/news/上海超导初登ASC国际舞台1.png",
          url: "/news/ascguoji",
          date: "2016-09-12",
          content: `2016年9月4日至9日，上海超导赴美参加了每两年一届的ASC大会。ASC大会，全称“The Applied Superconductivity Conference"，是超导界规模最大、规格最高的国际科学盛会，迄今为止已有50年的历史。本届ASC大会有超过1000位来自世界各地超导领域内的顶级科学家和工程师齐聚一堂，在研讨会上进行“思维碰撞”，互相交流、探讨最新的超导科研成果和技术突破，并为超导技术未来的发展方向提出新想法和新观点。在此次研讨会上，上海超导科研团队的吴蔚博士、吴祥博士和张智巍博士分别就上海超导的最新科研成果和技术突破作出报告，吸引了很多在场与会者的关注，并详细了解了我们带材制作的工艺。
          ---与研讨会同期同场地举行的是ASC展会，展会上有来自各国与超导相关的各个企业，例如：Ameriacan Superconductor、SuperPower、SuNAM等，向所有与会人员展示公司的最新进展、产品、技术以及服务。本次ASC展会，上海超导作为国内唯一一家参展参会的二代高温超导带材供应商全面登上ASC国际舞台，是国产二代高温超导带材“走出去”的重要里程碑。展会上，上海超导向世界各国的与会者们展示了公司自主研发、生产的不同型号样带并与之交流了上海超导带材的核心优势以及超导应用方向，最终获得了业内专家们的一致认可。
          ---自2011年公司成立之后，上海超导一直致力于打造具有独创性的优质国产二代高温超导带材。经过几年的努力，通过上海超导通过上海超导自主制造的生产线，上海超导开发出了具有性能全球领先的二代高温超导（YBCO）带材，成功打破了国外垄断，并推动了国内超导产业的发展。此次上海超导在ASC舞台上的绝佳表现，将成为公司产品全面向国际市场发力契机，力争在成为领跑世界的科技品牌同时，与国际伙伴一起共推超导产业，为人类社会的前进贡献一份力量。`,
          other: {
            picture1: {
              url: "/images/news/上海超导初登ASC国际舞台1.png",
              caption: "ASC大会现场",
            },
            picture2: {
              url: "/images/news/上海超导初登ASC国际舞台2.jpg",
              caption: "上海超导科研团队展示二代高温超导带材",
            },
            picture3: {
              url: "/images/news/上海超导初登ASC国际舞台3.jpg",
              caption: "ASC会议与展会现场",
            },
          },
        },
        {
          id: "kejichuangxin",
          title: '上海超导科技应邀亮相国家"十二五"科技创新成就展',
          image: "/images/news/科技创新成就展1.png",
          url: "/news/kejichuangxin",
          date: "2016-06-10",
          content: `2016年6月1日-7日，国家"十二五"科技创新成就展（以下简称展会）在北京展览馆开展。本次展会由科技部、国家发展改革委、财政部、军委装备发展部联合主办，集中展现了近五年来中国科技创新取得的重要进展和成果。习近平主席、李克强总理等各政治局常委，军委，国务院各部委，各省直辖市领导，两院院士，全国科协代表等均参观了此次展会，充分体现了国家对科技创新的高度重视。
          ---此次展出的科技成果可谓百花齐放，不仅有"天宫一号"、北斗导航系统、FAST超大射电望远镜等"国之重器"，也有与百姓生活紧密相关的集成电路制造技术、未来5G的研究进展、抗肿瘤新药、新型高温超导材料等新技术。上海超导科技作为上海市"十二五"期间重点培育的战略新兴高科技企业，应邀参加了本次会展，引起热烈反响。展会开幕的前一天5月31日晚，中国科学技术部部长万钢，副部长侯建国、李萌等领导受邀率先到现场体验了超导科技了"魔力"：经液氮冷却的超导体平稳地悬浮于永磁轨道上，并在轨道方向上高速旋转运动。上海超导科技市场部总监彭楚尧向万钢介绍，这是未来时速将超越飞机的超导悬浮低空列车的基础原理，其核心是第二代高温超导带材，目前已进入大规模产业化阶段。
          ---展会期间，中共中央政治局常委、十二届全国政协主席俞正声，中共中央政治局委员、第十二届全国人大常委会副委员长、全国总工会主席李建国，中共中央政治局委员、中央统战部部长孙春兰，第十二届全国人大常委会副委员长、新疆维吾尔自治区人大常委主任艾力更.依明巴海等领导先后到上海超导科技的展位进行了参观视察，就超导技术未来的发展方向进行了深入探讨，并对上海超导科技的成果给予了高度的肯定。此外，展会期间，到该公司展台采访、报道的媒体有：新华社、央视财经频道、北京电视台、北京青少年电视台、北京晨报、中国国际广播电台等等。其中，中央电视台新闻联播节目组对俞正声视察该公司展台进行了报道。
          ---上海超导科技成立于2011年，专注于研发与生产第二代高温超导带材(YBCO)。通过自主设计、制造的产线，实现了稳定量产高性价比的超导带材，具备卓越的低温强磁场性能(>1000A/cm, 4.2K, 12T)，定制化的带材封装工艺，以及超低阻接头(<25nΩ·cm2)。目前，二代高温超导带材可应用在电力电网、新型能源、高速交通、军工应用、新型能源、基础工业、大科学仪器等众多领域。
          ---[[highlight]]超导低空列车[[/highlight]]
          ---图里"冒白烟"的小飞碟正稳稳地悬浮在磁体轨道下方，这是因为我们把自主生产的二代高温超导带材编制成了小薄块置于塑料壳内，通过液氮给小飞碟降温，让里面的超导材料进入超导态，使其具有了完全抗磁性与量子锁定能力，从而使得小飞碟可以正向或反向悬浮，并顺着轨道快速飞行了。科学家们正在将这一原理用在轨道交通上，打造未来高铁——超导低空列车中。因为没有与地面的摩擦力，超导低空列车只受空气阻力影响，速度较高铁可提高2-3倍。目前国外科学家已利用该技术实现了603km/h的全球轨道交通最高时速，并于2014年开始在东京与名古屋之间兴建第一条商用化的超导低空列车运行线。如果未来超导低空列车能实现在真空管道内运行，那运行时速有可能达到2000-3000km/h甚至以上。
          ---[[highlight]]超导感应加热设备[[/highlight]]
          ---超导电缆是大容量电力输送的最佳技术方案之一，新一代超导电缆可采用YBCO涂层导体作为电流传输层，其载流能力至少可达同等尺寸的铜导线的5-10倍。同时输电损耗较常规电缆降低70-80%，且环境友好，无电磁辐射/热辐射。
          ---[[highlight]]超导电缆[[/highlight]]
          ---超导电缆是大容量电力输送的最佳技术方案之一，新一代超导电缆可采用YBCO涂层导体作为电流传输层，其载流能力至少可达同等尺寸的铜导线的5-10倍。同时输电损耗较常规电缆降低70-80%，且环境友好，无电磁辐射/热辐射。
          ---[[highlight]]超导电机[[/highlight]]
          ---与传统的电机相比，超导电机的能量损耗约为传统电机的20-30%，体积与重量分别减少约70-80%，同时可有效降噪、延长自持能力、节省运行成本。超导电机可应用于海上风力发电、舰船推进等装置。
          ---此次上海超导科技的技术成果作为上海市的亮点项目入选并亮相国家"十二五"科技创新成就展，标志着超导产业在"十二五"期间为促进经济转型升级，为推动供给侧结构改革做出了重要的贡献。作为国内二代高温超导带材的领军企业，上海超导自2011年成立以来，开始在国内布局超导产业，吸纳了一批业内优秀的人才，专注研发二代高温超导带材及其生产工艺。在短短五年内，上海超导已经从追赶美国、日本等国家研发的脚步，发展为国际上强有力的竞争者，并且目前与国内外多家科研机构、高校及企业都有深入地合作，为超导产业的发展，提供了强大的源动力。`,
          other: {
            picture1: {
              url: "/images/news/科技创新成就展1.png",
              caption: "上海超导科技展台",
            },
            picture2: {
              url: "/images/news/科技创新成就展2.png",
              caption: "中央领导参观上海超导科技展位",
            },
            picture3: {
              url: "/images/news/科技创新成就展3.png",
              caption: "超导体悬浮演示装置",
            },
            picture4: {
              url: "/images/news/科技创新成就展4.png",
              caption: "超导低空列车演示模型",
            },
            picture5: {
              url: "/images/news/科技创新成就展5.jpg",
              caption: "上海超导技术团队向领导介绍超导技术",
            },
            picture6: {
              url: "/images/news/科技创新成就展6.jpg",
              caption: "超导技术应用展示",
            },
            picture7: {
              url: "/images/news/科技创新成就展7.png",
              caption: "超导电缆展示模型",
            },
            picture8: {
              url: "/images/news/科技创新成就展8.jpg",
              caption: "科技创新成就展现场",
            },
          },
        },
        {
          id: "gaowengaoci",
          title: '上海超导成功承办"高温与高场超导材料及其应用技术研讨会"', // Use single quotes for the key's value to avoid conflict with inner double quotes
          image: "/images/news/高温与高场超导材料及其应用技术研讨会1.jpg",
          url: "/news/gaowengaoci",
          date: "2016-05-02",
          content: `2016年4月28-29日，"高温与高场超导材料及其应用研讨会"在上海市召开。本次研讨会由中科院高能物理研究所主办，上海交通大学、中科院合肥物质研究院协办，上海超导科技股份有限公司承办。会议由中科院高能物理研究所所长王贻方院士主持，北京大学甘子钊院士、中国科技大学万元熙院士、张裕恒院士、陈仙辉院士、台湾中央研究院吴茂昆院士、中科院物理所周兴江研究员、电工所林良真研究员、王秋良研究员、西北有色金属研究院张平祥院长、上海交通大学李贻杰教授等数十名超导机理、超导材料与超导应用等领域的专家，以及科技部、基金委、科学院、上海市科委的领导等应邀参会，在会上共同探讨了高温与高场超导材料的应用方向及应用难点，并对高温与高场超导技术的长期发展方向和思路提出了不同的看法和建议。上海交通大学校长张杰院士和上海市科委干频副主任出席会议并致欢迎辞。
          ---虽起步晚，但近年来我国在高温与高场超导材料的基础研究（机理、材料制备）及其应用技术方面取得显著进步，并达到国际一流水平。在超导应用上，我国也在奋起直追，尤其是由国内单位提议建设的一些大科学工程项目，如未来聚变工程试验项目（CFETR）及环形正负电子对撞机-超级质子对撞机项目（CEPC-SPPC）等，也拟采用超导技术，以提高装置性能，从而通过大科学工程项目的引领与带动，加速国内超导技术的发展及产业化进程。高温超导材料在电力能源、高端医疗设备、轨道交通、大科学工程、军工等领域有着广泛的应用前景。在本次研讨会上，业内专家一致表示，要实现高温超导材料产业化的破局，研究所、高效、企业及政府需要团结一致，通过不同应用领域大量需求的牵引，开展"从机理、材料制备到应用的全链条超导研究"，期望在5至10年内取得重大颠覆性突破，大幅度提高超导材料的性价比。
          ---上海超导作为国内首家能大规模量产二代高温超导带材的供应商，在高温超导材料应用上已有了不少进展，已与包括中科院高能物理研究所、中国科学院电工研究所、东方电气集团在内的十数家科研机构及企业在粒子加速器、超导电缆、超导电机等不同项目进行了合作。目前，上海超导已紧密参与到了中科院高能物理研究所牵头筹建的环形正负电子对撞机-超级质子对撞机（CEPC-SPPC）这个拟投资数百亿元的项目当中。双方的合作始于2014年下半年，并曾在2015年合作举办了"ICFA MINI – WORKSHOP ON HIGH FIELD MAGNETS FOR PP COLLIDERS" 研讨会，为高温超导材料在大科学工程上的应用和双方今后的合作奠定了基础。此次研讨会为双方合作举办的第二次围绕粒子加速器用高温超导材料的高层研讨会。
          ---研讨会期间，各位院士、领导、专家等专程到上海超导科技股份有限公司进行参观，对上海超导的整体构架、产品、发展思路都有了更深入的了解。上海超导所生产的带材因其全球领先的低温高场性能、一流的封装工艺、及先进的低阻接头技术受到专家和合作方的一致肯定。此次上海超导承办"高温与高场超导材料及其应用技术研讨会"，也是希望通过会议，与更多的科研机构和企业对接，共同探索高温超导材料在各个领域的应用价值，并力争在这一轮供给侧结构性改革中，为国家的经济发展做出实质性的贡献。`,
          other: {
            picture1: {
              url: "/images/news/高温与高场超导材料及其应用技术研讨会1.jpg",
              caption: "研讨会现场",
            },
            picture2: {
              url: "/images/news/高温与高场超导材料及其应用技术研讨会2.jpg",
              caption: "专家领导参观上海超导",
            },
            picture3: {
              url: "/images/news/高温与高场超导材料及其应用技术研讨会3.jpg",
              caption: "专家领导参观上海超导",
            },
            picture4: {
              url: "/images/news/高温与高场超导材料及其应用技术研讨会4.jpg",
              caption: "研讨会合影",
            },
          },
        },
        {
          id: "chaodaogaibianshenghuo",
          title: '超导改变生活，媒体争相报道：工博会"超导热"，再不来你就out啦',
          image: "/images/news/超导改变生活1.png", // Placeholder image
          url: "/news/chaodaogaibianshenghuo",
          date: "2015-11-20",
          content: `第17届中国国际博览会于11月3日在国家会展中心（上海）正式拉开帷幕此次工博会展示了中国在新能源、新材料、先进制造等领域的众多顶尖的科技成果。作为此次工博会高温超导行业的代表性企业，上海超导科技股份有限公司展台前总是人头攒动，一系列超导前沿产品引发的"超导热"也由各大媒体的报道将馆内的精彩传递给了更多的人。
          ---一走进6.2H会场的超导前沿馆，观众就会被位于"超导磁悬浮"展台冒着白气的，犹如腾云驾雾般在一只半米直径的透明圆盘漂浮着做圆周"奔跑"的"小飞碟"吸引。
          ---小飞碟之所以能快速移动，是因为其中内置了一片二代高温超导带YBCO超导带材。带材中超导层的厚度只有头发丝的千分之一至百分之一。只需要用比农夫山泉还便宜的液氮冷却超导带材就可以让带材处于超导态，然后处于超导态的超导带材就会让模型在永磁体铺成的"轨道"上.产生神奇的悬浮现象。
          ---目前，日本东海旅客铁路株式会社研发的超导磁悬浮列车，测试时速已经达到603公里/小时，为世界高铁之最，从东京到名古屋的超导磁悬浮铁路已于2014年正式动工兴建。更称奇的是，在低压管道中，超导磁悬浮列车可实现1500公里/小时的时速，理论时速可高达到1500公里/小时。
          ---[[highlight]]那么这个时候问题就来了，超导磁悬浮列车为何能实现"飞一般"的速度？这么快安全吗？[[/highlight]]
          ---超导磁悬浮列车利用超导材料的完全抗磁性（"迈斯纳效应"）与地面磁体产生相互排斥实现列车的悬浮，然后利用高温超导材料量子锁定的特性，将列车锁定在轨道之内。如此，加速完成之后列车前行基本无需动力，在真空下更可做到完全无动力行驶。
          ---相比起传统的电磁悬浮，超导磁悬浮技术可以在不需要通电的情况下实现更高的悬浮距离，从而更加安全、速度更快、并且能耗更低。该技术也是未来高速铁路发展最有前景的方向。
          ---[[highlight]]超导带材：紧贴市场需求，打破国外垄断，引领国际一流[[/highlight]]
          ---要想打造超导磁悬浮列车，最核心的元件就是高性能高温超导材料。经过数年研发，上海超导于2014年成为了国内唯一一家实现二代高温超导带材（YBCO）批量化生产与销售的企业，拥有完全自主知识产权，一举打破美国、日本在该领域的垄断地位。
          ---第三方评估数据显示，此次上海超导在工博会上展出的二代高温超导带材，磁场下性能比目前国际上最好的产品高出25%，同时价格降低了30%。此外，上海超导还自主研发了具有全球领先性能的"超低阻带材接头技术"，实现了2.3纳欧的全球最低工业接头电阻，加速了二代高温超导带材的大规模应用与产业化。
          ---可以说，上海超导开发的第二代高温超导带材是为数不多的中国自主开发"领先世界"的科技产品之一。
          ---除了"未来列车"，超导带材还能用在哪些领域？
          ---电网改造可为一例。目前以铜为主的高压电缆线不但尺寸大，而且损耗高。如果采用超导电缆，高温超导材料的零电阻特性可使输电损耗大幅降低，并将电缆的载流量提升数倍，同时还可实现电缆线从架在天上到埋入地下，还城市一个蓝色天空。超导电网的改造在美国已经开始。
          ---铝挤压行业是高能耗产业，传统感应加热器采用铜线圈通工频或中频交流电，在线圈内部的铝锭中产生交变磁场并感受涡流，从而加热铝锭，此种设备加热效率仅为40%左右，透热深度浅。应用超导感应加热技术，则可以利用无阻的超导线圈高效产生稳定的直流磁场，将加热能效提高到85%以上，同时还可大幅提高透热深度，显著提升金属加工件的质量。
          ---今年，上海超导与中科院合作，成功研制出了国内第一台"超导感应加热设备"，获得了超导感应加热领域全世界唯一有权的发明专利。目前，已经与多家铝加工企业达成合作意向。
          ---除了电力（超导电缆、超导限流器）、交通（超导磁悬浮）等提及应用，上海超导自主研发第二代高温超导带材还可应用于能源（可控核聚变、超导感应加热等）、医疗（磁共振成像等）等领域，为构建"绿色中国"贡献原创力量。
          ---[[highlight]]超导产线：全球唯一，推动中国高端制造业发展[[/highlight]]
          ---上海超导于2014年自主设计、制造了全球唯一一条可对外销售的"千米级"二代高温超导(YBCO)带材生产线，显著提高了二代高温超导带材的性能与经济性。该产线具有高度智能化、高度集成化、生产与测试一体化等特点，能稳定地量产出数百公里的超导带材。
          ---[[highlight]]我们需要多少超导产线和超导带材？[[/highlight]]
          ---近段时间媒体热议的中国将在2020年至2025年间开始建造世界上最大的强子对撞机的消息就与超导息息相关。强子对撞机原理即利用超导磁体产生的高能粒子束，形成碰撞，获得关于物质本源的信息，其终极目标是探索宇宙起源。此项工程投入将高达数百亿元，而上海超导将成为其中的高温超导带材提供商。`, // Extracted carefully, split by ---, added highlights
          other: {
            picture1: {
              url: "/images/news/超导改变生活1.png",
              caption: "超导磁悬浮演示",
            },
            picture2: {
              url: "/images/news/超导改变生活2.jpg",
              caption: "二代高温超导带材",
            },
            picture3: {
              url: "/images/news/超导改变生活3.jpg",
              caption: "上海超导生产线",
            },
            picture4: {
              url: "/images/news/超导改变生活4.jpg",
              caption: "超导磁悬浮列车",
            },
            picture5: {
              url: "/images/news/超导改变生活5.jpg",
              caption: "超导磁悬浮列车",
            },
            picture6: {
              url: "/images/news/超导改变生活6.jpg",
              caption: "超导磁悬浮列车",
            },
            picture7: {
              url: "/images/news/超导改变生活7.jpg",
              caption: "超导磁悬浮列车",
            },
          },
        },
        {
          id: "chuangxinchuangye",
          title: "上海超导荣获第四届中国创新创业大赛总决赛优秀企业奖",
          image:
            "/images/news/上海超导荣获第四届中国创新创业大赛总决赛优秀企业奖5.png", // Placeholder based on title and convention
          url: "/news/chuangxinchuangye",
          date: "2015-09-18",
          content: `2015年4月，第四届中国创新创业大赛拉开了帷幕，此次全国报名参赛的企业和团队达到了27000余个，涉及新材料、生物医药、先进制造、互联网、电子信息、新能源与节能环保等多个领域。对于新材料行业的企业来说，这次不仅是一场比赛，更是一个展示最新科研成果、推动新材料产业发展和加速中国科技发展的平台。
          ---上海超导科技股份有限公司在上海地区的总决赛中从数千家企业中脱颖而出，荣获第一名，晋级全国总决赛。2015年9月15日-17日，上海超导代表上海与全国新材料领域脱颖而出的157家企业齐聚在山东淄博，进行了项目的汇报和展示。
          ---在总决赛的舞台上，上海超导不仅展示了公司二代高温超导带材产品国际一流的性能、还向评委展示了全球首条自主设计并制造的高温超导带材"交钥匙"产线。同时，上海超导还向评委们展示了真正的"产学研用"四位一体的产品研发模式，以及"重研发、重市场、轻资产"的未来发展战略。上海超导年轻的精英科学家团队坚守于岗位上孜孜不倦地耕耘，让"中国制造"变为"中国创造"的愿景亦深深打动了现场评委与观众。最终，总决赛决出优秀企业48个，上海超导凭借"第二代高温超导带材项目"荣获了第四届中国创新创业大赛的优秀企业奖。
          ---赛后， 上海超导与对二代高温超导带材有投资意向的客户进行了进一步的接洽和讨论，让客户能对我们的产品本身和商业模式有一个更全面地了解，为之后进一步的合作奠定了基础。`, // Extracted content
          other: {
            picture1: {
              url: "/images/news/上海超导荣获第四届中国创新创业大赛总决赛优秀企业奖1.png", // Placeholder
            },
            picture2: {
              url: "/images/news/上海超导荣获第四届中国创新创业大赛总决赛优秀企业奖2.png", // Placeholder
            },
            picture3: {
              url: "/images/news/上海超导荣获第四届中国创新创业大赛总决赛优秀企业奖3.png", // Placeholder
            },
            picture4: {
              url: "/images/news/上海超导荣获第四届中国创新创业大赛总决赛优秀企业奖4.png", // Placeholder
            },
          },
        },
        {
          id: "zhongkeyuandian",
          title:
            "上海超导与中科院电工所正式签约合作国内首个百万级二代高温超导带材项目",
          image:
            "/images/news/上海超导与中科院电工所正式签约合作国内首个百万级二代高温超导带材项目1.jpg", // Placeholder based on title and number
          url: "/news/zhongkeyuandian",
          date: "2015-08-21",
          content: `2015年8月20日上午，上海超导科技股份有限公司与中国科学院电工研究所就二代高温超导带材合作协议举行签约仪式。
          ---此次签约，中标总额超过三百万元，是国内首个也是最大的第二代高温超导带材公开招标项目，标志着彼此双方建立了稳固的战略合作伙伴关系，为上海超导在高温超导带材研发，今后应用领域的发展奠定了良好的基础。
          ---在本次签约仪式上，上海超导科技股份有限公司和中国科学院电工研究所超导应用技术专业委员会都表示了建立长久合作的良好愿望。
          ---签约之后，上海超导总裁邱炜和本次会议出席的中天科技董事长薛济萍就高温超导的大规模应用、超导在电力与交通行业中的应用前景等几个话题进行了深入的探讨，交换了彼此的意见。双方都认为此次的订单，是一个里程碑式的转折点，它标志着第二代高温超导带材在商业领域应用的前景，这对国内高温超导整个产业来说，都是值得振奋的一个消息。
          ---上海超导科技股份有限公司作为国内领先的第二代高温超导带材研发公司，上海超导为中科院电工所提供高品质的第二代高温超导带材具有电流均匀性好，封装牢固性高，过流冲击性能大，失超后电阻高这四大特点。基于带材这些特点双方将在第二代高温超导带材应用等领域展开深层次的交流与合作。
          ---中国科学院电工研究所是我国目前从事电气科学研究的唯一国立研究机构。创建50多年来，电工所一直承担着国家能源与电气领域的战略高技术发展及电气科学前沿研究的任务，在电力系统自动化、大型电机、大型电感储能技术、超导磁体系统、磁流体发电等方面取得了科研成果500余项，其中100余项已在多个领域得到了推广应用，先后获得国家和中国科学院及其他部级奖励100余项。
       `,
          other: {
            picture1: {
              url: "/images/news/上海超导与中科院电工所正式签约合作国内首个百万级二代高温超导带材项目1.jpg", // Placeholder
              caption: "签约仪式现场", // Placeholder caption
            },
            // Add more picture placeholders if actual images exist
          },
        },
        {
          id: "icfa-workshop",
          title:
            "上海超导成功筹办ICFA Mini-workshop on High Field Magnets for pp Colliders",
          image: "/images/news/上海超导成功筹办ICFA1.jpg", // From attached file list
          url: "/news/icfa-workshop",
          date: "2015-06-20",
          content: `2015年6月15-17日，由中国科学院高能物理研究所主办、上海超导科技股份有限公司承办的 ICFA Mini-workshop on High Field Magnets for pp Colliders 国际会议在上海交通大学徐汇校区顺利举行。
          ---本次会议共有国内外超导和粒子加速器领域近60名专家、学者及科研工作者参加，其中包括来自中国科学院高能物理研究所的所长王贻芳、副所长秦庆，费米国家实验室的Prof. Weiren Chou， 劳伦斯伯克利国家实验室的Prof. Daniel Dietderich，布鲁克海文国家实验室的Prof. Ramesh Gupta 和Prof. Robert Palmer 等知名学者。本次会议围绕高场磁铁加速器的技术，高场磁体的设计制造方法，YBCO优异的高场性能等话题进行了广泛的交流与热烈的讨论。
          ---上海超导作为国内超导行业领先品牌应邀承办此次会议，上海超导充分发挥了自己的承办者的身份，出席本次专家在会后表示会议我们组织安排得很好、非常专业。业内同行对我们的高品质服务水准也交口称赞，同时本次会议促进了行业内专家学者的交流分享，在同行中起到了科研机构到企业连接的桥梁，充分展现了自己的技术实力，为本次会议的成功举办做出了突出贡献，获得了同行以及此次众多与会学者专家的一致好评。
          ---会后，与会者还受邀参观了上海超导总部。公司员工向与会者展示了包括二代高温超导镀膜产线、二代高温超导带材，以及基于二代高温超导带材的应用产品；其中超导带材在低温高场下具有优异的载流性能，深受国内外学者嘉宾的认可。`, // Extracted content
          other: {
            picture1: {
              url: "/images/news/上海超导成功筹办ICFA1.jpg",
              caption: "会议现场",
            },
            picture2: {
              url: "/images/news/上海超导成功筹办ICFA2.jpg",
              caption: "专家讨论",
            },
            picture3: {
              url: "/images/news/上海超导成功筹办ICFA3.jpg",
              caption: "参观上海超导总部",
            },
            picture4: {
              url: "/images/news/上海超导成功筹办ICFA4.jpg",
              caption: "参观上海超导总部",
            },
            picture5: {
              url: "/images/news/上海超导成功筹办ICFA5.jpg",
              caption: "与会者合影",
            },
          },
        },
        {
          id: "huadongzhenkong",
          title: "上海超导参展华东三省一市真空学术交流会",
          image: "/images/news/上海超导参展华东三省一市真空学术交流会1.jpg", // From attached file list
          url: "/news/huadongzhenkong",
          date: "2015-06-01",
          content: `2015年5月28-29日，第九届华东三省一市真空学术交流会在杭州顺利召开。本次交流会由浙江省真空学会承办，浙江、江苏、安徽、上海三省一市的高校、科研院所及相关企业共近80名科研人员参加。
          ---上海超导科技受邀参加本次学术交流会，与众多参会者探讨了真空领域的前沿、技术创新与开发等，并在本次交流会上作了"超导工艺及产线设备简介"的报告。
          ---华东三省一市真空学术交流会每两年举办一次，由上海、浙江、江苏、安徽四个省市的真空学会主办，以促进华东三省一市真空技术的进步和产业发展、推动新技术新产品的研发与应用，为真空领域的发展与进步提供很好的交流平台。`, // Extracted content
          other: {
            picture1: {
              url: "/images/news/上海超导参展华东三省一市真空学术交流会1.jpg",
              caption: "交流会现场或报告照片", // Placeholder caption
            },
          },
        },
        {
          id: "zhongbiaozhongke",
          title: "我公司中标中科院电工所的超导磁体用YBCO超导带材招标",
          image:
            "/images/news/我公司中标中科院电工所的超导磁体用YBCO超导带材招标2.png", // From attached file list and user request
          url: "/news/zhongbiaozhongke", // Shortened name for route
          date: "2015-03-25",
          content: `2015年3月，我公司在参加中科院电工所的超导磁体用YBCO超导带材的招标中，以优质的产品及服务在众多国内外知名公司中脱颖而出，成为中标单位。此次招标为中国市场上第一次公开的超过1公里的二代高温带材的招标，美国超导公司、美国SuperPower公司（现日本古河电工子公司）、英纳超导公司（韩国SuNAM代理商）均参与了此次招标。
          ---上海超导研发生产的YBCO超导带材能从美国、日本、韩国产品中脱颖而出，成为中国企业历史上第一次赢得二代高温超导带材的公开招标的公司，充分体现了我公司在YBCO超导带材方面雄厚的研发和生产实力，同时对于奠定中国高温超导的行业地位也具有深远意义。`, // Extracted content
          other: {
            picture1: {
              url: "/images/news/我公司中标中科院电工所的超导磁体用YBCO超导带材招标1.png",
              caption: "中标公告或相关图片", // Placeholder caption
            },
          },
        },

        {
          id: "xinghuan18t",
          title:
            "热烈祝贺星环聚能成功研制18TD形高温超导磁体，上海超导供应全部高温超导带材",
          image: "/images/news/星环聚能18T磁体1.jpg",
          url: "/news/xinghuan18t",
          date: "2024-02-05",
          content: `近日，星环聚能与清华大学合作、成功研制D形高温超导磁体原理样机，磁体内最高场强达18T，为目前国内公开报道D形磁体的最高场强。该磁体的成功运行为其下一代装置的设计奠定了坚实的基础，后续星环聚能将继续优化磁体设计和运行方案、冲击25T场强的设计目标。
          ---上海超导与星环聚能紧密合作，提供了该磁体绕制所需的高性能高温超导带材，后续上海超导将继续批量供应高性能高温超导带材，以支持其在高温超导聚变磁体的研发和创新。`,
          other: {
            picture1: {
              url: "/images/news/星环聚能18T磁体2.png",
              caption: "",
            },
            links: `<p><a href="https://startorus.cn/progress-news/251.html" target="_blank">星环聚能官网新闻</a></p>
                   <p><a href="https://mp.weixin.qq.com/s/r9KS3kd7bp2A0fEG4n4Gow" target="_blank">微信公众号报道</a></p>`,
          },
        },
        {
          id: "denglizitisuocicit",
          title:
            "热烈祝贺等离子体所研制全REBCO高温超导磁体并成功励磁至26.8T，上海超导供应高性能高温超导带材",
          image: "/images/news/等离子体所26.8T磁体1.jpg",
          url: "/news/denglizitisuocicit",
          date: "2025-01-30",
          content: `2024年1月30日，等离子体所及其联合研发团队在高温超导磁体研究方面取得重要突破。由等离子体物理研究所主导，合肥国际应用超导中心、合肥综合性国家科学中心能源研究院、合肥核聚磁体科技有限公司、清华大学以及合肥曦合超导科技有限公司共同参与研制的全REBCO高温超导磁体，在液氦浸泡条件下产生了26.8T的中心磁场，打破了全高温超导磁体26.4T最高记录，标志着我国高温超导磁体技术及高温超导材料性能均达到国际领先水平。
          ---上海超导提供了该磁体绕制所需的多种规格的高性能高温超导带材，为磁体的成功研制提供了关键的材料保障。
          ---上海超导与等离子体所长期保持紧密合作关系，此前已为其19.4T类CICC磁体、19.8T和24T全超导混合磁体、24.1T全REBCO磁体等项目供应高性能高温超导带材，磁体均成功达到设计指标。后续，上海超导将继续深化与等离子体所的合作，为高温超导磁体技术的发展和创新做出更大贡献。`,
          other: {
            picture1: {
              url: "/images/news/等离子体所26.8T磁体1.jpg",
            },
            picture2: {
              url: "/images/news/等离子体所26.8T磁体2.jpg",
            },
          },
        },
        {
          id: "manfuheyunxing",
          title:
            "热烈祝贺世界首条35千伏公里级超导输电示范工程实现满负荷运行，上海超导供应导体层全部高温超导带材",
          image: "/images/news/35千伏超导电缆工程1.jpg",
          url: "/news/manfuheyunxing",
          date: "2025-04-18",
          content: `热烈祝贺世界首条35千伏公里级超导输电示范工程实现满负荷运行，上海超导供应导体层全部高温超导带材。8月18日，世界首条35千伏公里级超导输电示范工程顺利实现满负荷运行，运行电流达2160.12安培，进一步刷新了我国商用超导输电工程最大实际运行容量的纪录。
          ---该项目于2019年2月启动，总长1.2公里，额定电流2200安培，采用"三芯"结构，电缆分为"导体层"和"屏蔽层"，均需要采用超导带材来制备，但功能不同，"导体层"带材用于传输电流，"屏蔽层"带材用于抵消导体层产生的磁场。本项目在上海市经信委的组织协调下，由上海电力公司、上海电缆研究所和上海国际超导公司牵头实施，完成了电缆系统的研发和制造，由上海的两家超导材料生产企业供应超导材料，上海超导供应了全部用于传输电流的导体层超导带材，因此本次大电流大负载试验通过，也再次肯定了我司产品的极限通流能力。
          ---该项目于2021年12月正式投运，目前已连续安全稳定运行超过600天，累计为上海徐家汇商圈、上海体育馆等核心区域4.9万户用户供电近3亿度，开创了公里级超导电缆在大型城市核心区域运行的先例。上海超导深感荣幸能成为该示范工程的主要供应商之一，近期上海超导正在进行整体搬迁，后续将充分发挥自身技术和产品领先优势，继续扩产扩能、进一步提升产品性能和交付能力。
          ---这一技术突破标志着我国在超导电力传输领域达到了国际领先水平，为未来5公里级超导电缆工程、超导可控核聚变等规模化商业应用和示范项目奠定了坚实基础。上海超导将继续致力于高温超导材料的技术创新和产业化发展，为全球超导应用提供高质量的材料支撑。`,
          other: {
            picture1: {
              url: "/images/news/35千伏超导电缆工程1.jpg",
            },
            picture2: {
              url: "/images/news/35千伏超导电缆工程2.jpg",
            },
            picture3: {
              url: "/images/news/35千伏超导电缆工程3.jpg",
            },
            picture4: {
              url: "/images/news/35千伏超导电缆工程4.jpg",
            },
          },
        },
        {
          id: "zongbudijikaiong",
          title: "喜讯！上海超导带材及总部基地正式开工",
          image: "/images/news/上海超导带材及总部基地正式开工.png",
          url: "/news/zongbudijikaiong",
          date: "2025-06-29",
          content: `6月29日，上海超导二代高温超导带材生产及总部基地项目开工仪式顺利举行，本项目成功入选2025年上海市重大建设项目计划，将建设全球首个大工业化级别第二代高温超导带材生产研发基地，达产后年产能1.5万公里，将占据全球产能绝对领先地位。
            ---上海超导依托多年技术积累与经验，将打造第二代高温超导带材制备产线，持续提高公司第二代高温超导带材的生产效率和工艺水平，扩大公司整体业务规模、拓展下游应用范围，提升公司在面向可控核聚变、超导电缆、超导磁体等应用的大批量稳定供货能力和产品性能优势，提高公司的核心竞争能力和发展后劲，引领下游能源、电力、医疗、交通、大科学装置应用领域的创新应用，促进超导及相关产业集群发展，为上海乃至全国的超导产业升级和发展注入新动力。
            ---值得一提的是，在张江十余个部门的通力合作下，本项目在土地交付当日同步取得用地规划许可证、设计方案批复、审图证、施工许可证、土地不动产权证，达成"五证连发"，是张江第一个同时实现"拿地即开工""交地即交证"的项目。`,
          other: {
            picture1: {
              url: "/images/news/上海超导带材及总部基地正式开工.png",
            },
          },
        },
        {
          title: "上海超导MT29会议展风采，2025上半年参展精彩一览",
          image: "/images/news/上海超导MT29会议展风采1.png",
          url: "/news/mt29huiyi",
          date: "2025-07-01",
          content: `7月1日，第29届国际磁体技术会议（2025 International Conference on Magnet Technology, MT29）在美国波士顿顺利召开。本次会议围绕磁体的研究、制造、测试、运行及配套的低温制冷技术等议题，吸引了全球约1000多位磁体领域的专家和工程师齐聚一堂。
            ---上海超导受邀参展本次盛会，总裁朱佳敏博士在会上作专题报告，向与会代表详细介绍了上海超导的扩产进展及难点，分享了上海超导依托一期扩产经验及以往向多个超导项目大批量供货的成功经验，高效有序地推进二期扩产进程。未来，上海超导将继续加强与全球合作伙伴的交流与合作，共同推动高温超导产业迈向高质量发展的新阶段。
            ---值得关注的是，除带材厂商常规的公司进展报告外，上海超导还荣幸获邀在EUCAS 2025两大核心会场发表特邀报告——这标志着中国高温超导材料供应商首次获得国际顶尖学术会议的专业认可。届时，上海超导将在Materials Sub Committee组织的"The Future of Coated Conductors"焦点会场、Large-scale Committee组织的"Industry-Led Projects on Superconducting Power Cable"特别会场分别做专题报告。
            ---同期，上海超导也将与业内同行一样设立展位，欢迎各位专家学者莅临交流。

            ---回顾2025上半年，上海超导积极投身于行业内多个重量级会议及展会，全方位展示了上海超导在高温超导带材领域的专业实力与科研创新能力。
            ---[[highlight]]01 "超导材料及高场磁体技术发展研讨会"暨第二十四次高温超导合作组会[[/highlight]]
            ---1月10日-12日，由"实用化高温超导材料产学研合作组"主办、上海超导承办的"超导材料及高场磁体技术发展研讨会"暨第二十四次高温超导合作组会在上海顺利召开。会议以"超导材料及高场磁体技术发展研讨"为主题，全国超导相关领域的4位两院院士作为专项顾问专家出席会议，20余家科研院所及高校的120多位超导领域专家、学者参会，共同回顾合作组各单位协同发展的十年历程，总结其带动我国高温超导材料技术和产业进步的情况，并展望和研讨超导磁体未来应用的技术发展前景。
            ---上海超导有幸承办本次会议，与参会专家和学者们深入交流了公司在研发、扩产、国内外项目供货等方面的进展，为后续合作及业务拓展奠定基础。
            ---[[highlight]]02 2025国际涂层导体应用研讨会(2025 International Workshop on Coated Conductors for Applications, CCA2025)[[/highlight]]
            ---3月11日-13日，2025国际涂层导体应用研讨会(2025 International Workshop on Coated Conductors for Applications, CCA2025)在瑞士日内瓦成功举办。会议聚焦涂层导体制造、应用研究、电磁电机械性能研究、磁体应用研究、电力应用研究等五大议题。
            ---上海超导有幸受邀参加本次会议，积极参与讨论涂层导体材料科学、制造和应用、应用现状与前景、挑战和机遇等方面的问题，与国际同行共同探索行业发展未来路径。
            ---[[highlight]]03 2025上海全球投资促进大会暨"投资上海"活动周[[/highlight]]
            ---3月25日，2025上海全球投资促进大会暨"投资上海"活动周正式开幕。大会以"全球视野·上海机遇"为主题，面向全球企业家和投资者推介上海，共享发展新机遇，共绘开放合作新图景。
            ---会上，21个重点产业项目落地启动，涵盖先进材料、集成电路、数字经济等产业领域。其中，上海超导的"超导二代高温超导带材生产及总部基地项目"落地浦东新区，建设全球首个大工业化级别第二代高温超导带材生产研发基地。
            ---[[highlight]]04 第三届中国（安徽）科技创新成果转化交易会[[/highlight]]
            ---4月26-28日，第三届中国（安徽）科技创新成果转化交易会在合肥顺利召开，会议以"科技打头阵，创新赢未来"为主题，开展成果发布、技术对接、项目洽谈等活动，以科技创新引领新质生产力发展。
            ---上海超导有幸受邀参展本次科交会，展示了上海超导近期的产品研发进展、应用项目供货等情况。公司副董事长洪智勇受邀出席超导材料供需专项对接活动，介绍新产品4mm宽Slitlesss®第二代高温超导带材的性能及应用方向，并代表上海超导与中科院合肥物质院签约"聚变磁体用高温超导关键材料国产化"项目，为聚变应用贡献力量。
            ---[[highlight]]05 第十八届全国超导学术研讨会[[/highlight]]
            ---6月6日-10日，第十八届全国超导学术研讨会（NCSC2025）在上海成功举办，会议由国家超导技术联合研究开发中心主办，涵盖超导物理与新型超导体、实用超导材料与磁通动力学、超导强电应用、超导弱电应用和低温制冷&超导测试与标准共5个议题，全国超导相关领域的8位两院院士、360多家科教单位的1200余名科技工作者、大学院校师生及企业工程技术人员参加本次会议。
            ---上海超导有幸受邀参展本次会议，总裁朱佳敏博士受邀作大会报告，向参会的专家、学者和行业技术人员分享上海超导的最新研发成果、扩产进展等情况，上海超导将继续稳步提升面向可控核聚变、超导电缆、超导磁体等应用项目的大批量供货能力，为超导超导产业发展和超导应用推进提供关键材料支撑作用。
            ---2025年上半年，上海超导通过积极参与各类国际国内会议及展会，不仅展示了自身的技术实力和创新能力，同时也加强了与国内外同行的交流与合作，为公司的持续发展和行业的进步做出了积极贡献。未来，上海超导将继续秉持创新发展的理念，深耕技术创新与突破，为超导产业的发展贡献更多力量。`,
          other: {
            picture1: {
              url: "/images/news/上海超导MT29会议展风采1.png",
            },
            picture2: {
              url: "/images/news/上海超导MT29会议展风采2.png",
            },
            picture3: {
              url: "/images/news/上海超导MT29会议展风采3.png",
            },
            picture4: {
              url: "/images/news/上海超导MT29会议展风采4.png",
            },
            picture5: {
              url: "/images/news/上海超导MT29会议展风采5.png",
            },
            picture6: {
              url: "/images/news/上海超导MT29会议展风采6.png",
            },
            picture7: {
              url: "/images/news/上海超导MT29会议展风采7.png",
            },
            picture8: {
              url: "/images/news/上海超导MT29会议展风采8.png",
            },
          },
        },
      ],
    },
  },
  downloads: {
    title: "资料下载",
    content: "资料下载",
  },
};
